<template>
    <div>
        <!-- New cost -->
        <v-row no-gutters class="align-center font-weight-bold">
            <v-col cols="8" class="mt-n1">
                <span>General Terms</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="d-flex justify-end">
                <v-btn
                    v-if="
                        quote.generatedByClient &&
                            (quote.product === 'LOUVER' || !quote.product)
                    "
                    color="primary"
                    dark
                    class="mb-2 mr-2 rounded-xl"
                    text
                    @click="calculatorDialog = true"
                >
                    <v-icon left>mdi-calculator</v-icon>
                    Calculator Items
                </v-btn>
                <v-btn
                    v-if="
                        (quote.status === 'OPEN' ||
                            quote.status === 'APPROVAL') &&
                            !history
                    "
                    color="primary"
                    dark
                    class="mb-2 mr-0 rounded-xl"
                    text
                    @click="dialogImportScope = true"
                >
                    <v-icon left>mdi-import</v-icon>
                    Import
                </v-btn>
                <v-dialog v-model="importDialog" max-width="800px">
                    <ImportCosts
                        v-if="importDialog"
                        :quote="quote"
                        @importCosts="importCosts"
                        @importAlternates="importAlternates"
                        @close="importDialog = false"
                    />
                </v-dialog>
                <v-dialog v-model="importScopesDialog" max-width="800px">
                    <ImportScopes
                        v-if="importScopesDialog"
                        :quote="quote"
                        @importScopes="importScopes"
                        @close="importScopesDialog = false"
                    />
                </v-dialog>
                <v-dialog
                    :retain-focus="false"
                    v-model="createDialogNewCost"
                    persistent
                    max-width="1400px"
                    :fullscreen="$vuetify.breakpoint.mobile"
                >
                    <NewQuoteCostForm
                        v-if="
                            (quote.status === 'OPEN' ||
                                quote.status === 'APPROVAL') &&
                                !history &&
                                createDialogNewCost
                        "
                        :originalCost="{}"
                        :createCostForm="createCostForm"
                        :installationEditable="true"
                        title="New Item"
                        :quote="quote"
                        :costs="costs"
                        :cost="newItemCost"
                        :loading="loading"
                        :settings="settings"
                        :alternative="alternative"
                        :action="action"
                        :quoteProductTypes="quoteProductTypes"
                        :engineers="
                            users.filter(
                                u =>
                                    u.permissions &&
                                    u.permissions.includes('uploadPreDesign')
                            )
                        "
                        @saveAlternative="saveAlternative"
                        @closeDialog="closeDialog"
                        @createCosts="createCosts"
                        @updateCosts="updateCosts"
                        @updateCostInLocal="updateCostInLocal"
                    />
                </v-dialog>
            </v-col>
        </v-row>

        <!-- General terms -->
        <v-row class="pb-2" no-gutters>
            <v-col
                cols="4"
                xl="1"
                lg="1"
                md="1"
                sm="1"
                xs="1"
                class="d-flex align-center"
            >
                <span>Sales Exch. Rates</span>
            </v-col>
            <v-col
                v-if="quote"
                cols="4"
                lg="2"
                md="2"
                sm="1"
                xs="1"
                class="d-flex align-center"
            >
                <v-dialog v-model="exchangeForm" max-width="500px" persistent>
                    <template v-slot:activator="{ on, attrs }">
                        <span>{{ quote.currency + ' ' + quote.exchange }}</span>
                        <v-btn
                            v-if="
                                (quote.status === 'OPEN' ||
                                    quote.status === 'APPROVAL') &&
                                    !history
                            "
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="openExchangeForm"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <v-card :loading="loading">
                        <v-card-title>
                            <span class="text-h5">Update Exchange</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="6">
                                        <v-autocomplete
                                            :disabled="
                                                (quote.status !== 'OPEN' &&
                                                    quote.status !==
                                                        'APPROVAL') ||
                                                    history
                                            "
                                            flat
                                            hide-details
                                            v-model="temporaryCurrency"
                                            :items="itemsCurrency"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            :disabled="
                                                (quote.status !== 'OPEN' &&
                                                    quote.status !==
                                                        'APPROVAL') ||
                                                    history
                                            "
                                            flat
                                            prefix="$"
                                            hide-details
                                            v-model="temporaryExchange"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="red"
                                text
                                @click="exchangeForm = false"
                            >
                                Cancel
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="
                                    (quote.status === 'OPEN' ||
                                        quote.status === 'APPROVAL') &&
                                        !history
                                "
                                color="blue darken-1"
                                rounded
                                depressed
                                dark
                                :loading="loading"
                                @click="updateExchange"
                            >
                                Update
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col
                cols="4"
                xl="1"
                lg="1"
                md="1"
                sm="1"
                xs="1"
                class="d-flex align-center"
            >
                <span>Surcharges</span>
            </v-col>

            <v-col
                cols="8"
                xl="11"
                lg="11"
                md="11"
                sm="11"
                xs="11"
                v-if="quote"
                class="d-flex flex-wrap align-center"
            >
                <v-card
                    flat
                    v-for="(com, i) in quote.commissions"
                    :key="i"
                    @click="openDialogDelete(com)"
                >
                    <div class="d-flex flex-column  ma-4">
                        <span class="text-singleline my-2">{{
                            com.details
                        }}</span>
                        <span class="text-singleline"
                            >{{ com.percentage }}%</span
                        >
                    </div>
                </v-card>
                <v-btn
                    v-if="
                        (quote.status === 'OPEN' ||
                            quote.status === 'APPROVAL') &&
                            !history
                    "
                    @click="openDialogCommissions"
                    depressed
                    class="ml-2"
                    fab
                    x-small
                    color="primary"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>

                <CommissionForm
                    v-if="
                        (quote.status === 'OPEN' ||
                            quote.status === 'APPROVAL') &&
                            !history
                    "
                    v-model="dialogCommissions"
                    title="Add Commission"
                    :createForm="true"
                    @closeDialog="closeDialogCommissions"
                    @addCommission="addCommissions"
                />
                <CommissionForm
                    v-if="
                        (quote.status === 'OPEN' ||
                            quote.status === 'APPROVAL') &&
                            !history
                    "
                    v-model="deleteCommissions"
                    title="Commission"
                    :createForm="false"
                    @closeDialog="closeDialogDelete"
                    :commission="comToDelete"
                    @deleteCommission="deleteCommission"
                    @updateCommission="updateSalesRepCommission"
                />
            </v-col>
        </v-row>

        <!-- View Mode Toggle -->
        <v-row no-gutters class="pb-2">
            <v-col
                cols="4"
                xl="1"
                lg="1"
                md="1"
                sm="1"
                xs="1"
                class="d-flex align-center"
            >
                <span>View Mode</span>
            </v-col>
            <v-col
                cols="8"
                xl="11"
                lg="11"
                md="11"
                sm="11"
                xs="11"
                class="d-flex align-center"
            >
                <v-switch
                    v-model="showOriginalView"
                    color="primary"
                    hide-details
                    dense
                    class="mt-0"
                >
                    <template v-slot:label>
                        <span class="text-caption">
                            {{
                                showOriginalView
                                    ? `Alternative (${displayCurrency})`
                                    : `Original (${quote.currency})`
                            }}
                        </span>
                    </template>
                </v-switch>
            </v-col>
        </v-row>

        <v-data-table
            :loading="loading"
            :headers="headers"
            class="elevation-0 mt-8"
            :items="costsOnTable"
            :mobile-breakpoint="0"
            hide-default-footer
            disable-pagination
        >
            <template v-slot:top>
                <v-toolbar
                    flat
                    :style="{ 'background-color': '#eeeeee !important' }"
                >
                    <v-toolbar-title>ITEMS</v-toolbar-title>
                    <v-btn icon small class="ml-2" @click="createXLSX"
                        ><v-icon>mdi-download</v-icon></v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="
                            (quote.status === 'OPEN' ||
                                quote.status === 'APPROVAL') &&
                                !history
                        "
                        depressed
                        color="primary"
                        @click="newCost"
                        rounded
                        class="ml-7"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        <span>New Item</span>
                    </v-btn>
                </v-toolbar>
            </template>
            <!--ITEMS-->
            <template v-slot:body>
                <draggable
                    :list="costsOnTable"
                    tag="tbody"
                    :force-fallback="true"
                    @change="onMoveCallback"
                    handle=".handle"
                >
                    <tr
                        v-for="(item, index) in costsOnTable"
                        :key="item.id"
                        @mouseover="handle = item.id"
                        @mouseleave="handle = undefined"
                    >
                        <td class="handle">
                            <div class="d-flex justify-center">
                                <v-icon
                                    :class="{ invisible: item.id != handle }"
                                    :style="{ cursor: 'grab' }"
                                >
                                    mdi-pan-vertical
                                </v-icon>
                            </div>
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.reference }}</td>
                        <td>{{ item.category || '' }}</td>
                        <td>
                            {{
                                item.quantity && item.quantity != null
                                    ? Number(item.quantity).toFixed(2)
                                    : '--'
                            }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(getDisplayValue(item, 'total'))
                            }}
                        </td>
                        <td>
                            {{ itemMargin(item) }}
                        </td>
                        <td>
                            {{ itemGrossMargin(item) }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(
                                    getDisplayValue(item, 'pricePerQuantity')
                                )
                            }}
                            / {{ item.measure }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(getDisplayValue(item, 'salePrice'))
                            }}
                        </td>
                        <td class="d-flex justify-center pt-2">
                            <v-btn icon small @click.stop="editItem(item)">
                                <v-icon
                                    v-if="
                                        quote.status === 'OPEN' ||
                                            quote.status === 'APPROVAL'
                                    "
                                    small
                                    >mdi-pencil</v-icon
                                >
                                <v-icon v-else small>mdi-eye-outline</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                small
                                @click.stop="deleteItem(item)"
                                :disabled="
                                    (quote.status !== 'OPEN' &&
                                        quote.status !== 'APPROVAL') ||
                                        history
                                "
                            >
                                <v-icon small>mdi-trash-can</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                small
                                @click.stop="copyItem(item)"
                                :disabled="
                                    (quote.status !== 'OPEN' &&
                                        quote.status !== 'APPROVAL') ||
                                        history
                                "
                            >
                                <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                small
                                @click.stop="openTaskDialog(item)"
                                :disabled="
                                    (quote.status !== 'OPEN' &&
                                        quote.status !== 'APPROVAL') ||
                                        history
                                "
                                v-if="createTask"
                            >
                                <v-icon small
                                    >mdi-plus-box-multiple-outline</v-icon
                                >
                            </v-btn>
                        </td>
                    </tr>
                </draggable>

                <tbody>
                    <tr class="costs-table-footer">
                        <td></td>
                        <td></td>
                        <td class="font-weight-bold text-left">TOTALS</td>
                        <td></td>
                        <td></td>
                        <td class="font-weight-bold text-left">
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(footerTotal.cost)
                            }}
                        </td>
                        <td class="font-weight-bold text-left">
                            {{ footerTotal.margin.toFixed(2) + '%' }}
                        </td>
                        <td class="font-weight-bold text-left">
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(footerTotal.grossMargin)
                            }}
                        </td>
                        <td></td>
                        <td class="font-weight-bold text-left">
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(
                                    showOriginalView
                                        ? costsOnTable &&
                                          Array.isArray(costsOnTable) &&
                                          costsOnTable.length > 0
                                            ? costsOnTable.reduce(
                                                  (sum, cost) =>
                                                      sum +
                                                      getDisplayValue(
                                                          cost,
                                                          'salePrice'
                                                      ),
                                                  0
                                              )
                                            : 0
                                        : totals == 0
                                        ? quote.totalCosts
                                        : totals
                                )
                            }}
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>

        <v-data-table
            :loading="loading"
            :headers="headersAlternatives"
            class="elevation-0 mt-8"
            :items="currentAlternatives"
            :mobile-breakpoint="0"
            hide-default-footer
            disable-pagination
        >
            <template v-slot:top>
                <v-toolbar
                    flat
                    :style="{ 'background-color': '#eeeeee !important' }"
                >
                    <v-toolbar-title>ALTERNATES</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="
                            (quote.status === 'OPEN' ||
                                quote.status === 'APPROVAL') &&
                                !history
                        "
                        depressed
                        color="primary"
                        @click="openAddAlternative = true"
                        rounded
                        class="ml-7"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        <span>ADD ALTERNATE</span>
                    </v-btn>
                </v-toolbar>
            </template>
            <!--ITEMS-->
            <template v-slot:body>
                <draggable
                    :list="currentAlternatives"
                    tag="tbody"
                    :force-fallback="true"
                    @change="onMoveCallbackAlternates"
                    handle=".handle2"
                >
                    <tr
                        v-for="(item, index) in currentAlternatives"
                        :key="item.id"
                        @mouseover="handle2 = item.id"
                        @mouseleave="handle2 = undefined"
                    >
                        <td class="handle2">
                            <div class="d-flex justify-center">
                                <v-icon
                                    :class="{ invisible: item.id != handle2 }"
                                    :style="{ cursor: 'grab' }"
                                >
                                    mdi-pan-vertical
                                </v-icon>
                            </div>
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.reference }}</td>
                        <td>{{ item.category || '' }}</td>
                        <td>
                            {{
                                item.quantity && item.quantity != null
                                    ? Number(item.quantity).toFixed(2)
                                    : '--'
                            }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                }).format(
                                    getDisplayValue(item, 'pricePerQuantity')
                                )
                            }}
                            / {{ item.measure }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(getDisplayValue(item, 'salePrice'))
                            }}
                        </td>
                        <td>
                            {{
                                new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: displayCurrency,
                                    maximumFractionDigits: 2,
                                }).format(getItemsPrice(item))
                            }}
                        </td>
                        <td>
                            {{ calDifference(item) }}
                        </td>
                        <td class="d-flex justify-center">
                            <v-menu rounded offset-y>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        depressed
                                        class="mt-3"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click.stop="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon
                                                v-if="
                                                    quote.status === 'OPEN' ||
                                                        quote.status ===
                                                            'APPROVAL'
                                                "
                                                small
                                                >mdi-pencil</v-icon
                                            >
                                            <v-icon v-else small
                                                >mdi-eye-outline</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            {{
                                                quote.status === 'OPEN' ||
                                                quote.status === 'APPROVAL'
                                                    ? 'Update'
                                                    : 'View'
                                            }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click.stop="
                                            comToDelete = item
                                            openDeleteDialog = true
                                        "
                                        :disabled="
                                            (quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                history
                                        "
                                    >
                                        <v-list-item-icon class="">
                                            <v-icon small>mdi-trash-can</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Delete
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :disabled="
                                            (quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                history
                                        "
                                        @click.stop="copyAlternate(item)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon small
                                                >mdi-content-copy</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Copy
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :disabled="
                                            (quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                history
                                        "
                                        @click.stop="replaceCosts(item)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon small>mdi-check</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Approve
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :disabled="
                                            (quote.status !== 'OPEN' &&
                                                quote.status !== 'APPROVAL') ||
                                                history
                                        "
                                        @click.stop="openChangeBID(item)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon small
                                                >mdi-swap-horizontal</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Change BID
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </draggable>
            </template>
        </v-data-table>

        <v-dialog
            :retain-focus="false"
            v-model="categoryField"
            max-width="400px"
            persistent
        >
            <v-card v-if="categoryField">
                <v-card-title
                    ><v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        small
                        @click="categoryField = false"
                    >
                        <v-icon>mdi-close</v-icon> </v-btn
                    >ADD CATEGORY</v-card-title
                >
                <v-divider class="ml-4 mr-5"></v-divider>
                <v-card-text class="pb-0">
                    <v-row class="pt-3">
                        <v-col cols="12">
                            The selected alternative does not have an associated
                            category.
                        </v-col>
                    </v-row>
                    <v-form v-model="valid" ref="form">
                        <v-row no-gutters class="my-2">
                            <v-col cols="12">
                                <v-autocomplete
                                    flat
                                    dense
                                    solo
                                    required
                                    hide-details
                                    placeholder="Cost category for invoicing"
                                    :rules="[rules.required]"
                                    class="text-body-2"
                                    :items="categories"
                                    item-text="name"
                                    item-value="name"
                                    v-model="cloneAlternate.category"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn
                                @click="replaceCosts(cloneAlternate)"
                                text
                                color="primary"
                                :disabled="!valid"
                            >
                                SAVE
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- alternative dialog -->
        <v-dialog
            :retain-focus="false"
            v-model="openAddAlternative"
            persistent
            max-width="400px"
        >
            <v-card v-if="openAddAlternative">
                <v-card-title class="text-h5">ADD ALTERNATE</v-card-title>
                <v-card-text>
                    <v-form v-model="valid" ref="form">
                        <v-row no-gutters class="my-2">
                            <v-col cols="12">
                                <v-text-field
                                    label="Name *"
                                    v-model="alternativeName"
                                    hide-details
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="my-2">
                            <v-col cols="12">
                                <v-select
                                    v-model="alternatives"
                                    :items="currentItems"
                                    label="Select"
                                    chips
                                    hint="Select one or more items."
                                    persistent-hint
                                    item-text="reference"
                                    item-value="id"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="my-2">
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="copyItems"
                                    label="Copy costs."
                                    hide-details
                                    :disabled="
                                        !alternatives ||
                                            alternatives.length == 0
                                    "
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex">
                            <v-btn
                                text
                                color="secondary"
                                @click="closeAddAlternative"
                            >
                                CANCEL
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                @click="addAlternatives"
                                text
                                color="primary"
                                :disabled="!valid"
                            >
                                CREATE
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- delete cost -->

        <v-dialog
            :retain-focus="false"
            v-model="deleteDialog"
            persistent
            max-width="400px"
        >
            <v-card>
                <v-card-title class="text-h5">Delete Cost</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this cost?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="deleteDialog = false">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteCosts"
                        text
                        color="error"
                        :disabled="!permission"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- delete alternative -->

        <v-dialog
            :retain-focus="false"
            v-model="openDeleteDialog"
            persistent
            max-width="400px"
        >
            <v-card>
                <v-card-title class="text-h5">Delete Alternative</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this alternative?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="openDeleteDialog = false"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteAlternative" text color="error">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            :retain-focus="false"
            v-model="editDialog"
            persistent
            max-width="1400px"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <NewQuoteCostForm
                v-if="editDialog && quote && editDialog"
                :copyCost="copyCost"
                title="Edit Item"
                :quote="quote"
                :costs="costs"
                :editAlternative="editAlternative"
                :installationEditable="true"
                :originalCost="originalCost"
                :cost="this.costToEdit"
                :settings="settings"
                :alternative="alternative"
                :action="action"
                :quoteProductTypes="quoteProductTypes"
                :engineers="
                    users.filter(
                        u =>
                            u.permissions &&
                            u.permissions.includes('uploadPreDesign')
                    )
                "
                @closeDialog="closeEditItem"
                :loading="loading"
                @updateCosts="updateCosts"
                @updateCostsInstallation="updateCostsInstallation"
                @updateAlternativeCosts="updateAlternativeCosts"
                @saveAlternative="saveAlternative"
                @updateCostInLocal="updateCostInLocal"
            />
        </v-dialog>
        <!-- task  -->
        <v-dialog
            :retain-focus="false"
            v-model="openTaskForm"
            persistent
            max-width="640px"
        >
            <TaskForm
                v-if="openTaskForm"
                :task="selectedTask"
                :originalTask="selectedTask"
                :createForm="createForm"
                :fromCosts="true"
                @closeDialog="closeTaskDialog"
            />
        </v-dialog>
        <v-alert
            :type="action.type"
            :color="action.color"
            :style="{ position: 'absolute', bottom: 0, right: 0 }"
            dismissible
            v-if="action.type == 'success' && action.active"
        >
            {{ action.message }}
        </v-alert>
        <!--CHANGE BID-->
        <v-dialog
            :retain-focus="false"
            v-model="changeBIDDialog"
            persistent
            max-width="640px"
        >
            <ChangeBID
                v-if="changeBIDDialog"
                :alternate="selectedAlternate"
                :costs="costs"
                :quoteId="quote.id"
                @changeBID="changeBID"
                @close="closeChangeBID"
            />
        </v-dialog>
        <v-dialog
            :retain-focus="false"
            v-model="dialogImportScope"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="text-h5 py-3">
                    <v-btn
                        class="mr-1"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="dialogImportScope = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span>Import a cost</span>
                </v-card-title>
                <v-card-text>
                    Select an option to import your cost.
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mt-2" plain @click="importDialog = true">
                        <v-icon>mdi-import</v-icon>
                        <span class="mt-1">Import from a quote</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mt-2"
                        text
                        plain
                        @click="importScopesDialog = true"
                    >
                        <v-icon>mdi-import</v-icon>
                        <span class="mt-1">Import from My Scopes</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <CalculatorItemsDialog
            v-model="calculatorDialog"
            :quoteId="quote.id"
            :currency="quote.currency"
            :quoteStatus="quote.status"
            :quoteModel="quote.model"
            :scheduleMessage="quote.scheduleMessage || ''"
            :costs-subtotal="costsSubtotalForComparison"
            @update:scheduleMessage="onScheduleMessage"
            @update:quoteModel="onQuoteModel"
            @close="calculatorDialog = false"
        />
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import CommissionForm from '@/components/Quotes/CommissionForm'
import API from '@/services/api'
import NewQuoteCostForm from '@/components/Quotes/NewQuoteCostForm'
import _ from 'lodash'
import moment from 'moment'
import { storage } from '@/services/firebase'
import convert from 'convert-units'
import * as XLSX from 'xlsx/xlsx.mjs'
import Draggable from 'vuedraggable'
import TaskForm from '@/components/Tasks/TaskForm.vue'
import ImportCosts from '../../components/Quotes/ImportCosts.vue'
import { saveFile } from '@/services/storage/saveFile.js'
import ImportScopes from '@/components/Scopes/ImportScopes.vue'
import CalculatorItemsDialog from '@/components/Quotes/CalculatorItemsDialog.vue'
import { costKind } from '@/utils/costKind.js'
import {
    marginsForCommissions,
    mergeSalesRepCommissions,
    quoteSalesRepIds,
    salesRepCommissionShare,
    salesRepCommissionsManual,
    salesRepPercentKey,
    commissionBaseUsd,
} from '@/utils/salesRepQuoteCommissions.js'

export default {
    name: 'QuoteCosts',
    components: {
        NewQuoteCostForm,
        CommissionForm,
        Draggable,
        TaskForm,
        ImportCosts,
        ImportScopes,
        CalculatorItemsDialog,
        ChangeBID: () => import('@/components/Quotes/ChangeBID.vue'),
    },
    props: {
        id: String,
        quote: Object,
        settings: Array,
        costs: Array,
        costVersions: Object,
        history: {
            type: Boolean,
            default: false,
        },
    },
    // Function provided from the mainboard
    inject: {
        filterQuotes: {
            from: 'filterQuotes',
            default: null,
        },
        spreadCosts: {
            from: 'spreadCosts',
            default: null,
        },
        replaceQuoteLocal: {
            from: 'replaceQuoteLocal',
            default: () => null,
        },
    },
    data() {
        return {
            dialogImportScope: false,
            importScopesDialog: false,
            calculatorDialog: false,
            selectedAlternate: undefined,
            permission: false,
            changeBIDDialog: false,
            createCostForm: false,
            createTask: false,
            handle: undefined,
            handle2: undefined,
            createForm: true,
            selectedTask: {},
            openTaskForm: false,
            openDeleteDialog: false,
            editAlternative: false,
            alternative: false,
            alternativeName: '',
            copyItems: false,
            items: [
                { id: 1, name: 'primero' },
                { id: 2, name: 'segundo' },
            ],
            alternatives: [],
            openAddAlternative: false,
            headers: [
                {
                    text: '',
                    value: 'handle',
                    sortable: false,
                    align: 'left',
                    class: 'grey lighten-3',
                    width: 10,
                },
                {
                    text: '#',
                    value: 'index',
                    class: 'grey lighten-3',
                },
                {
                    text: 'DESCRIPTION',
                    value: 'reference',
                    class: 'grey lighten-3',
                },
                {
                    text: 'CATEGORY',
                    value: 'category',
                    class: 'grey lighten-3',
                },
                {
                    text: 'QTY',
                    value: 'quantity',
                    class: 'grey lighten-3',
                },
                {
                    text: 'COST',
                    value: 'cost',
                    class: 'grey lighten-3',
                },
                {
                    text: 'MARGIN',
                    value: 'margin',
                    class: 'grey lighten-3',
                },
                {
                    text: 'GROSS MARGIN',
                    value: 'grossMargin',
                    class: 'grey lighten-3',
                },
                {
                    text: 'PRICE PER QUANTITY',
                    value: 'pricePerQuantity2',
                    class: 'grey lighten-3',
                },
                {
                    text: 'SALE PRICE',
                    value: 'salePrice2',
                    class: 'grey lighten-3',
                },
                {
                    text: 'ACTION',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-3',
                },
            ],
            headersAlternatives: [
                {
                    text: '',
                    value: 'handle',
                    sortable: false,
                    align: 'left',
                    class: 'grey lighten-3',
                    width: 10,
                },
                {
                    text: '#',
                    value: 'index',
                    class: 'grey lighten-3',
                },
                {
                    text: 'DESCRIPTION',
                    value: 'reference',
                    class: 'grey lighten-3',
                    sortable: false,
                },
                {
                    text: 'CATEGORY',
                    value: 'category',
                    class: 'grey lighten-3',
                    sortable: false,
                },
                {
                    text: 'QTY',
                    value: 'quantity',
                    class: 'grey lighten-3',
                },
                {
                    text: 'PRICE PER QUANTITY',
                    value: 'pricePerQuantity2',
                    class: 'grey lighten-3',
                },
                {
                    text: 'SALE PRICE',
                    value: 'salePrice2',
                    class: 'grey lighten-3',
                },
                {
                    text: 'BASE BID',
                    value: 'price',
                    class: 'grey lighten-3',
                },
                {
                    text: 'DELTA',
                    value: 'difference',
                    class: 'grey lighten-3',
                },
                {
                    text: 'ACTION',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-3',
                },
            ],
            cloneAlternate: null,
            categories: [],
            categoryField: false,
            totalCosts: 0,
            loading: false,
            costsOnTable: [],
            itemsCurrency: [],
            globalCurrency: null,
            exchanges: [],
            error: null,
            errorMsg: null,
            deleteDialog: false,
            copyCost: false,
            createDialogNewCost: false,
            settingExchange: [],
            editDialog: false,
            costToEdit: null,
            exchange: null,
            copyExchange: null,
            copyCurrency: null,
            dialogCommissions: false,
            deleteCommissions: false,
            originalCost: null,
            comToDelete: {},
            sumCommissions: 0,
            exchangeForm: false,
            temporaryExchange: '',
            temporaryCurrency: '',
            newItemCost: {
                totalSections: [],
                sections: [],
                total: 0,
                total2: 0,
                totalMargin2: 0,
                commission2: 0,
                quantity2: 0,
                salePrice2: 0,
                pricePerQuantity2: 0,
                margin: 40,
                measure: 'ft2',
                totalMargin: 0,
                commission: 0,
                salePrice: 0,
                pricePerQuantity: 0,
                american: {
                    tw: 0,
                    wa: 0,
                    cw: 0,
                    pw: 0,
                    ca: 0,
                },
                international: {
                    tw: 0,
                    wa: 0,
                    cw: 0,
                    pw: 0,
                    ca: 0,
                },
            },
            folderClientsPictures: 'clients_pictures',
            folderUsersPictures: 'users_pictures',
            companyId: JSON.parse(localStorage.getItem('company')),
            user: JSON.parse(localStorage.getItem('userId')),
            quantityInternational: 0,
            importDialog: false,
            importedQuote: null,
            quotes: [],
            importLoading: false,
            importError: false,
            importedCosts: [],
            oldQuote: Object.assign({}, this.quote),
            valid: false,
            rules: { required: v => !!v || 'The value is required' },
            currentAlternatives: [],
            isMounted: false,
            arItems: undefined,
            action: { active: false },
            quoteProductTypes: [],
            showOriginalView: false, // false = converted view (default), true = original view
            alternativeViewCosts: [], // Converted values for alternative view
            alternativeViewAlternatives: [], // Converted alternates
            alternativeViewExchange: 1, // Exchange for alternative view conversion
            alternativeViewCurrency: '', // Currency of the alternative view
            // ponytail: skip alt-view recalc on reorder (index-only); ceiling = stale alt view until next real cost change
            skipAlternativeViewRecalc: false,
            // ponytail: skip quote watcher during exchange convert; ceiling = missed client/contact hydrate until next quote edit
            skipQuoteWatch: false,
            syncingSalesRepCommissions: false,
        }
    },
    watch: {
        quote: {
            async handler(newQuote, oldQuote) {
                if (this.skipQuoteWatch) return
                this.updateSeeMenuAction(false)
                this.copyTerms()
                if (!this.quote.client) {
                    const {
                        data: { clients },
                    } = await API.getClient({ clientId: this.quote.clientId })
                    this.quote.client = clients
                }
                if (this.contacts.length === 0) {
                    await this.getContacts()
                }
                if (this.users.length === 0) {
                    await this.getUsers()
                }
                if (!this.quote.mainContact) {
                    this.quote.mainContact = this.users.find(
                        user => this.quote.userId == user.id
                    )
                }
                this.updateSeeMenuAction(true)

                // If exchange or currency changed and toggle is active, recalculate alternative view
                // Use $nextTick to wait for convertCost() to finish updating data
                if (
                    this.showOriginalView &&
                    oldQuote &&
                    (newQuote?.exchange !== oldQuote?.exchange ||
                        newQuote?.currency !== oldQuote?.currency)
                ) {
                    this.$nextTick(() => {
                        this.calculateAlternativeView()
                    })
                }
            },
            deep: true,
        },
        action: function() {
            if (this.action.active) {
                setTimeout(() => {
                    this.action.active = false
                }, 5000)
            }
        },
        getAlternatives: {
            handler(newAlternatives) {
                if (newAlternatives && newAlternatives.length > 0) {
                    this.currentAlternatives = newAlternatives.map(alt => ({
                        ...alt,
                        documentId: alt.id,
                    }))
                } else {
                    this.currentAlternatives = []
                }
            },
            immediate: true,
        },
        showOriginalView: {
            handler(newValue) {
                if (newValue) {
                    this.calculateAlternativeView()
                }
            },
            immediate: false,
        },
        costs: {
            handler() {
                if (this.skipAlternativeViewRecalc) return
                if (this.showOriginalView) {
                    this.calculateAlternativeView()
                }
            },
            deep: true,
        },
        currentAlternatives: {
            handler() {
                if (this.skipAlternativeViewRecalc) return
                if (this.showOriginalView) {
                    this.calculateAlternativeView()
                }
            },
            deep: true,
        },
        'quote.totalCosts'(value, oldValue) {
            if (this.syncingSalesRepCommissions) return
            if (oldValue == null || Number(value) === Number(oldValue)) return
            this.syncSalesRepCommissions()
        },
        getPendingAction: {
            handler(action) {
                if (!action) return
                if (action.type === 'openCostForm') {
                    this.handleOpenCostFormAction(action.payload)
                    this.clearPendingAction()
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState(['contacts', 'users', 'clients']),
        ...mapGetters(['getAlternatives', 'getPendingAction']),
        totals: function() {
            return this.totalCosts
        },
        currentExchange: function() {
            if (this.quote) {
                return this.quote.exchange
            } else {
                return 0
            }
        },
        currentItems() {
            if (this.costsOnTable && this.costsOnTable.length > 0) {
                return this.costsOnTable
            } else {
                return this.costs
            }
        },
        footerTotal() {
            let totals = {
                cost: 0,
                margin: 0,
                grossMargin: 0,
            }

            // Validate that costsOnTable exists
            if (!this.costsOnTable || !Array.isArray(this.costsOnTable)) {
                return totals
            }

            let totalCommission = 0
            if (this.quote && this.quote.commissions) {
                this.quote.commissions.forEach(commission => {
                    totalCommission += parseFloat(commission.percentage) / 100
                })
            }

            this.costsOnTable.forEach(cost => {
                if (!cost.exportTariff) {
                    const total = this.getDisplayValue(cost, 'total')
                    const salePrice = this.getDisplayValue(cost, 'salePrice')
                    totals.cost += total
                    totals.grossMargin +=
                        salePrice - total - salePrice * totalCommission
                } else {
                    totals.grossMargin += 0
                }
            })
            const totalSalePrice = this.costsOnTable.reduce(
                (sum, cost) => sum + this.getDisplayValue(cost, 'salePrice'),
                0
            )

            totals.margin =
                totalSalePrice > 0
                    ? (totals.grossMargin * 100) / totalSalePrice
                    : 0

            return totals
        },
        // Currency to display according to view
        displayCurrency() {
            if (this.showOriginalView) {
                // Alternative view: display in opposite currency
                return this.alternativeViewCurrency || 'USD'
            }
            // Original view: display in quote currency
            return this.quote && this.quote.currency
                ? this.quote.currency
                : 'COP'
        },
        // Exchange to display according to view
        displayExchange() {
            if (this.showOriginalView) {
                return this.alternativeViewExchange || 1
            }
            return this.quote && this.quote.exchange ? this.quote.exchange : 1
        },
        costsSubtotalForComparison() {
            const clientName = (this.quote.client?.name || '').toLowerCase()
            const isSolarEnergy =
                clientName.includes('energía solar') ||
                clientName.includes('energia solar')
            const city = (this.quote.shipToCity || '').toLowerCase()
            const includeFreight = isSolarEnergy && city === 'barranquilla'
            const INCLUDED_KINDS = [
                'impactLouver',
                'blankOffPanel',
                'backPan',
                'sillPan',
                'birdScreen',
            ]
            return (this.costs || []).reduce((sum, cost) => {
                const kind = costKind(cost)
                if (INCLUDED_KINDS.includes(kind)) {
                    return sum + (cost.salePrice2 || 0)
                }
                if (kind === 'freight' && includeFreight) {
                    return sum + (cost.salePrice2 || 0)
                }
                return sum
            }, 0)
        },
    },
    methods: {
        onScheduleMessage(value) {
            this.$set(this.quote, 'scheduleMessage', value)
        },
        onQuoteModel(value) {
            this.$set(this.quote, 'model', value)
        },
        isExportTariffCost(cost) {
            return (
                cost?.exportTariff === true || costKind(cost) === 'exportTariff'
            )
        },
        stripCostMetadataForUpdate(cost) {
            delete cost.createdOn
            delete cost.updatedOn
            delete cost.documentId
            delete cost.engineeringExitDate
            delete cost.preDesignReturned
            delete cost.onHoldReasons
            delete cost.engExitBy
            delete cost.engIngressBy
            delete cost.engineeringIngressDate
            delete cost.productType
            delete cost.syncedExportTariff
            delete cost.syncedTotalCosts
            delete cost.kind
            if (!this.isExportTariffCost(cost)) {
                delete cost.accessory
                delete cost.exportTariff
            }
        },
        extractSyncedQuoteFields(cost) {
            const synced = {
                syncedExportTariff: cost?.syncedExportTariff,
                syncedTotalCosts: cost?.syncedTotalCosts,
            }
            delete cost?.syncedExportTariff
            delete cost?.syncedTotalCosts
            return synced
        },
        applySyncedExportTariffToQuote(synced) {
            if (synced?.syncedExportTariff != null) {
                this.quote.exportTariff = synced.syncedExportTariff
            }
            if (synced?.syncedTotalCosts != null) {
                this.quote.totalCosts = synced.syncedTotalCosts
            }
        },
        ...mapMutations(['setAlternatives', 'setErrorItems']),
        // Helper to get a quote version with alternative currency and exchange
        getAlternativeQuote() {
            if (!this.showOriginalView) {
                return this.quote
            }

            // Create a copy of the quote with alternative values
            const alternativeQuote = _.cloneDeep(this.quote)
            alternativeQuote.currency = this.alternativeViewCurrency
            alternativeQuote.exchange = this.alternativeViewExchange

            return alternativeQuote
        },
        // Helper to get the value to display according to view
        getDisplayValue(item, field) {
            if (this.showOriginalView) {
                // Alternative view: use converted values to opposite currency
                const convertedItem =
                    this.alternativeViewCosts.find(c => c.id === item.id) ||
                    this.alternativeViewAlternatives.find(
                        a => a.id === item.id
                    ) ||
                    item
                const altSalePrice =
                    convertedItem.alternativeSalePrice2 ||
                    convertedItem.salePrice2 ||
                    0

                switch (field) {
                    case 'total':
                        return (
                            convertedItem.alternativeTotal2 ||
                            convertedItem.total ||
                            0
                        )
                    case 'salePrice':
                        return (
                            convertedItem.alternativeSalePrice2 ||
                            convertedItem.salePrice ||
                            0
                        )
                    case 'commission':
                        return (
                            convertedItem.alternativeCommission2 ||
                            convertedItem.commission ||
                            0
                        )
                    case 'totalMargin':
                        return (
                            convertedItem.alternativeTotalMargin2 ||
                            convertedItem.totalMargin ||
                            0
                        )
                    case 'pricePerQuantity':
                        // Calculate price per unit in the ORIGINAL unit (item.measure)
                        // Use alternativeSalePrice2 (converted) / quantity (original)

                        return item.quantity > 0
                            ? altSalePrice / item.quantity
                            : 0
                    default:
                        return 0
                }
            } else {
                // Original view: use current converted values (quote.currency)
                switch (field) {
                    case 'total':
                        return item.total2 || item.total || 0
                    case 'salePrice':
                        return item.salePrice2 || item.salePrice || 0
                    case 'commission':
                        return item.commission2 || item.commission || 0
                    case 'totalMargin':
                        return item.totalMargin2 || item.totalMargin || 0
                    case 'pricePerQuantity':
                        // Calculate price per unit in the ORIGINAL unit (item.measure)
                        // This is the original calculation that worked correctly
                        return item.quantity > 0
                            ? (item.salePrice2 || 0) / item.quantity
                            : 0
                    default:
                        return 0
                }
            }
        },
        calculateAlternativeView() {
            try {
                const quoteCurrency =
                    this.quote && this.quote.currency
                        ? this.quote.currency
                        : 'COP'
                const quoteExchange =
                    this.quote && this.quote.exchange ? this.quote.exchange : 1

                // Determine the opposite currency to the quote currency
                const oppositeCurrency = quoteCurrency === 'USD' ? 'COP' : 'USD'

                // Determine which exchange to use
                let exchangeToUse = 1

                if (quoteExchange !== 1) {
                    // If quote.exchange !== 1, use that exchange
                    exchangeToUse = quoteExchange
                } else {
                    // If quote.exchange === 1, find exchange in settings for the opposite currency
                    const oppositeExchange = this.exchanges?.find(
                        ex => ex.currency === oppositeCurrency
                    )
                    exchangeToUse = oppositeExchange
                        ? parseFloat(oppositeExchange.money)
                        : 4100
                }

                this.alternativeViewCurrency = oppositeCurrency
                this.alternativeViewExchange = exchangeToUse

                // Convert costs
                this.alternativeViewCosts = (this.costs || []).map(cost => {
                    return this.convertCostForAlternativeView(cost)
                })

                // Convert alternatives
                this.alternativeViewAlternatives = (
                    this.currentAlternatives || []
                ).map(alt => {
                    return this.convertCostForAlternativeView(alt)
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message:
                        'Error calculating alternative view. Please try again.',
                })
                // Disable toggle
                this.showOriginalView = false
            }
        },
        convertCostForAlternativeView(cost) {
            // Create a deep copy of the cost
            const converted = _.cloneDeep(cost)

            // Determine if the destination currency is the global currency
            // If it's the global, base values are already in that currency (don't divide)
            // If it's not the global, convert by dividing by the exchange
            const isDestinationGlobal =
                this.alternativeViewCurrency ===
                this.settingExchange?.globalCurrency

            if (isDestinationGlobal) {
                // If destination currency is global, base values are already in that currency
                // Don't divide, use directly
                converted.alternativeTotal2 = converted.total
                converted.alternativeSalePrice2 = converted.salePrice
                converted.alternativeCommission2 = converted.commission
                converted.alternativeTotalMargin2 = converted.totalMargin
                converted.alternativePricePerQuantity2 =
                    converted.pricePerQuantity
            } else {
                // If destination currency is NOT global, convert by dividing by the exchange
                converted.alternativeTotal2 = parseFloat(
                    (
                        Number(converted.total) /
                        Number(this.alternativeViewExchange)
                    ).toFixed(2)
                )
                converted.alternativeSalePrice2 = parseFloat(
                    (
                        Number(converted.salePrice) /
                        Number(this.alternativeViewExchange)
                    ).toFixed(2)
                )
                converted.alternativeCommission2 = parseFloat(
                    (
                        Number(converted.commission) /
                        Number(this.alternativeViewExchange)
                    ).toFixed(2)
                )
                converted.alternativeTotalMargin2 = parseFloat(
                    (
                        Number(converted.totalMargin) /
                        Number(this.alternativeViewExchange)
                    ).toFixed(2)
                )

                // Don't calculate pricePerQuantity2 here yet - will be calculated after convertUnits
            }

            // Create a temporary version of the cost with converted values
            // to apply statistics (american and international)
            const tempCost = _.cloneDeep(converted)
            tempCost.total2 = converted.alternativeTotal2
            tempCost.salePrice2 = converted.alternativeSalePrice2

            // Apply the same unit conversions and statistics as convertions()
            // This recalculates quantity2 according to the unit of measure
            this.convertUnits(tempCost)

            // NOW calculate pricePerQuantity2 with the correct quantity2
            // Only if destination currency is NOT global (already calculated above if it's global)
            if (!isDestinationGlobal) {
                converted.alternativePricePerQuantity2 = parseFloat(
                    (
                        Number(converted.alternativeSalePrice2) /
                        Number(tempCost.quantity2)
                    ).toFixed(2)
                )
            }

            // Continue with statistics
            this.convertAmericanStatistics(tempCost)
            this.convertInternationalStatistics(tempCost)

            // Save converted statistics
            converted.alternativeAmerican = _.cloneDeep(tempCost.american)
            converted.alternativeInternational = _.cloneDeep(
                tempCost.international
            )
            converted.alternativeQuantity2 = tempCost.quantity2

            return converted
        },
        updateCostInLocal(cost) {
            if (cost.type == 'cost') {
                const index = this.costs.findIndex(c => cost.id == c.id)
                if (index >= 0) {
                    this.costs.splice(index, 1, { ...this.costToEdit, ...cost })
                    this.costsOnTable.splice(index, 1, {
                        ...this.costToEdit,
                        ...cost,
                    })
                }
            } else if (cost.type == 'alternate') {
                const index = this.currentAlternatives.findIndex(
                    a => a.id == cost.id
                )
                this.currentAlternatives[index] = _.cloneDeep(cost)
                this.currentAlternatives = [...this.currentAlternatives]
                this.setAlternatives(this.currentAlternatives)
            }
        },
        async onMoveCallbackAlternates(evt) {
            if (evt.moved) {
                const index = evt.moved.newIndex
                let beforeIndex = 0
                let afterIndex = 0
                if (index > 0) {
                    beforeIndex = this.currentAlternatives[index - 1].index
                }
                if (index < this.currentAlternatives.length - 1) {
                    afterIndex = this.currentAlternatives[index + 1].index
                } else if (index == this.currentAlternatives.length - 1) {
                    afterIndex = beforeIndex + 1
                }
                this.skipAlternativeViewRecalc = true
                this.currentAlternatives[index].index =
                    (beforeIndex + afterIndex) / 2
                this.$nextTick(() => {
                    this.skipAlternativeViewRecalc = false
                })
                await API.updateCosts(this.quote.id, {
                    id: this.currentAlternatives[index].id,
                    index: this.currentAlternatives[index].index,
                })
            }
        },
        async copyAlternate(alternate) {
            try {
                this.loading = true
                this.alternative = true
                const costSections = this.settings
                    .find(s => s.name === 'Quotes')
                    ?.costSections?.map(cs => cs.name)
                this.costToEdit = _.cloneDeep(alternate)
                delete this.costToEdit.id
                delete this.costToEdit.index
                delete this.costToEdit.type
                delete this.costToEdit.createdOn
                delete this.costToEdit.exportTariff
                delete this.costToEdit.updatedOn
                delete this.costToEdit.documentId
                delete this.costToEdit.productType
                //////clean data/////
                this.costToEdit.sections = this.costToEdit.sections.filter(s =>
                    costSections?.includes(s.name)
                )
                this.costToEdit.totalSections = this.costToEdit.totalSections.filter(
                    s => costSections?.includes(s.secName)
                )
                this.originalCost = _.cloneDeep(this.costToEdit)
                this.copyCost = false
                this.editDialog = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeChangeBID() {
            this.selectedAlternate = {}
            this.changeBIDDialog = false
        },
        openChangeBID(item) {
            this.selectedAlternate = _.clone(item)
            this.changeBIDDialog = true
        },
        async changeBID(cost) {
            try {
                const index = this.currentAlternatives.findIndex(
                    a => a.id == cost.id
                )
                if (index >= 0) {
                    this.costToEdit = {
                        ...this.currentAlternatives[index],
                        ...cost,
                    }
                    await this.updateAlternativeCosts()
                }
                this.closeChangeBID()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        itemGrossMargin(item) {
            // let totalCommission = 0
            // if (this.quote && this.quote.commissions) {
            //     this.quote.commissions.forEach(commission => {
            //         totalCommission += parseFloat(commission.percentage) / 100
            //     })
            // }
            let grossMargin = 0

            if (!item.exportTariff) {
                // const total = this.getDisplayValue(item, 'total')
                // const salePrice = this.getDisplayValue(item, 'salePrice')
                grossMargin = item.totalMargin2 || 0 //salePrice - total - salePrice * totalCommission
            } else {
                grossMargin = 0
            }
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: this.displayCurrency,
                maximumFractionDigits: 2,
            }).format(grossMargin)
        },
        itemMargin(item) {
            // let totalCommission = 0
            // if (this.quote && this.quote.commissions) {
            //     this.quote.commissions.forEach(commission => {
            //         totalCommission += parseFloat(commission.percentage) / 100
            //     })
            // }
            let grossMargin = 0
            if (!item.exportTariff) {
                // const total = this.getDisplayValue(item, 'total')
                // const salePrice = this.getDisplayValue(item, 'salePrice')
                grossMargin = item.totalMargin2 || 0 //salePrice - total - salePrice * totalCommission
            } else {
                grossMargin = 0
            }

            const salePrice = this.getDisplayValue(item, 'salePrice')
            const margin = salePrice > 0 ? (grossMargin * 100) / salePrice : 0

            return margin.toFixed(2) + '%'
        },
        closeTaskDialog() {
            this.openTaskForm = false
            this.selectedTask = {}
        },
        openTaskDialog(item) {
            this.openTaskForm = true
            this.selectedTask = {
                quoteId: this.quote.id,
                cost: item.id + '/' + item.reference,
            }
        },
        async onMoveCallback(evt) {
            if (evt.moved) {
                const index = evt.moved.newIndex
                let beforeIndex = 0
                let afterIndex = 0
                if (index > 0) {
                    beforeIndex = this.costsOnTable[index - 1].index
                }

                if (index < this.costsOnTable.length - 1) {
                    afterIndex = this.costsOnTable[index + 1].index
                } else if (index == this.costsOnTable.length - 1) {
                    afterIndex = beforeIndex + 1
                }
                this.skipAlternativeViewRecalc = true
                this.costsOnTable[index].index = (beforeIndex + afterIndex) / 2
                // shallow copy is enough: order changed, cost objects unchanged
                this.spreadCosts([...this.costsOnTable])
                this.$nextTick(() => {
                    this.skipAlternativeViewRecalc = false
                })
                await API.updateCosts(this.quote.id, {
                    id: this.costsOnTable[index].id,
                    index: this.costsOnTable[index].index,
                })
            }
        },
        openExchangeForm() {
            this.temporaryCurrency = _.cloneDeep(this.quote.currency)
            this.temporaryExchange = _.cloneDeep(this.quote.exchange)
            this.exchangeForm = true
        },
        async updateExchange() {
            this.loading = true
            try {
                this.quote.currency = this.temporaryCurrency
                this.quote.exchange = this.temporaryExchange
                // convertions() runs sync before the first await; close dialog on the new numbers
                const persist = this.convertCost()
                this.exchangeForm = false
                await persist
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async replaceCosts(item) {
            try {
                this.categoryField = false
                this.loading = true
                this.error = false
                this.errorMsg = ''

                if (!item.category) {
                    this.cloneAlternate = _.cloneDeep(item)
                    this.categoryField = true
                } else {
                    this.createCostFromAlternative(item)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async createCostFromAlternative(item) {
            try {
                this.loading = true
                // Get the complete document as it comes from the database
                const selectedAlternative = _.cloneDeep(item)
                // Save the cost to be replaced
                let newCost = await API.approveAlternate({
                    quoteId: this.quote.id,
                    alternateId: item.id,
                })
                const index = this.costs.findIndex(cost =>
                    selectedAlternative.alternatives.includes(cost.id)
                )
                if (index >= 0) {
                    this.costs.splice(index, 1)
                }
                this.costs.push(newCost)
                // Calculate total costs
                this.totalCosts = this.costs.reduce(
                    (acumulator, cost) => acumulator + cost.salePrice2,
                    0
                )
                // Allocate the total cost to the quotation
                this.quote.totalCosts = this.totalCosts
                // REPLACE COSTS
                this.costsOnTable = _.cloneDeep(this.costs)
                // REMOVE ALTERNATE
                this.currentAlternatives = this.currentAlternatives.filter(
                    a => a.id != item.id
                )
                this.setAlternatives(_.cloneDeep(this.currentAlternatives))
                this.replaceQuoteAction({
                    id: this.quote.id,
                    quote: this.quote,
                })
                this.replaceQuoteLocal(this.quote.id, { ...this.quote })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        calDifference(item) {
            const salePrice = this.getDisplayValue(item, 'salePrice')
            const difference = salePrice - this.getItemsPrice(item)
            if (difference < 0) {
                return `DED ${new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: this.displayCurrency,
                }).format(difference * -1)}`
            } else if (difference > 0) {
                return `ADD ${new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: this.displayCurrency,
                }).format(difference)}`
            } else {
                return `${new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: this.displayCurrency,
                }).format(difference)}`
            }
        },
        getItemsPrice(item) {
            const alternate = this.currentAlternatives.find(
                a => a.id == item.id
            )

            if (
                !alternate ||
                !alternate.alternatives ||
                alternate.alternatives.length == 0
            ) {
                return 0
            }
            let total = 0
            for (let cost of this.costs) {
                if (alternate.alternatives.includes(cost.id)) {
                    total += this.getDisplayValue(cost, 'salePrice')
                }
            }
            return total
        },
        async deleteAlternative() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''
                await API.deleteCosts(this.quote.id, this.comToDelete.id)
                const copyAlternatives = _.cloneDeep(this.getAlternatives)
                const index = copyAlternatives.findIndex(
                    a => a.id == this.comToDelete.id
                )
                copyAlternatives.splice(index, 1)
                this.setAlternatives(_.cloneDeep(copyAlternatives))
                this.currentAlternatives = this.currentAlternatives.filter(
                    a => a.id != this.comToDelete.id
                )
                this.openDeleteDialog = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateAllAlternatives() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''
                for (let cost of this.getAlternatives) {
                    await API.updateCosts(this.quote.id, {
                        ...cost,
                        ...(cost.engineeringDate &&
                        typeof cost.engineeringDate == 'object'
                            ? {
                                  engineeringDate: moment
                                      .unix(
                                          cost.engineeringDate._seconds ||
                                              cost.engineeringDate.seconds
                                      )
                                      .format('YYYY-MM-DD'),
                              }
                            : {}),
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async updateAlternativeCosts() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''
                const index = this.currentAlternatives.findIndex(
                    a => a.id == this.costToEdit.id
                )
                this.currentAlternatives[index] = _.cloneDeep(this.costToEdit)
                delete this.costToEdit.createdOn
                delete this.costToEdit.createdBy
                delete this.costToEdit.updatedOn
                delete this.costToEdit.documentId
                delete this.costToEdit.engineeringDate
                delete this.costToEdit.engineering
                delete this.costToEdit.engineeringIngressDate
                delete this.costToEdit.engineeringExitDate
                if (!this.isExportTariffCost(this.costToEdit)) {
                    delete this.costToEdit.exportTariff
                }
                delete this.costToEdit.preDesignReturned
                delete this.costToEdit.onHoldReasons
                delete this.costToEdit.engIngressBy
                if (!this.isExportTariffCost(this.costToEdit)) {
                    delete this.costToEdit.accessory
                }
                delete this.costToEdit.engExitBy
                delete this.costToEdit.productType
                const copyCost = _.cloneDeep(this.costToEdit)
                delete copyCost.preDesign
                await API.updateCosts(this.quote.id, {
                    ...copyCost,
                    ...(copyCost.engineeringDate &&
                    typeof copyCost.engineeringDate == 'object'
                        ? {
                              engineeringDate: moment
                                  .unix(
                                      copyCost.engineeringDate._seconds ||
                                          copyCost.engineeringDate.seconds
                                  )
                                  .format('YYYY-MM-DD'),
                          }
                        : {}),
                })
                this.setAlternatives(this.currentAlternatives)
                this.currentAlternatives = [...this.currentAlternatives]
                this.createDialogNewCost = false
                this.editDialog = false
                this.action = {
                    active: true,
                    type: 'success',
                    message: 'Action successfully completed',
                    color: 'primary',
                }
            } catch (error) {
                this.action = {
                    active: true,
                    type: 'error',
                    message: 'Error executing the action',
                    color: 'error',
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeAddAlternative() {
            this.createDialogNewCost = false
            this.openAddAlternative = false
            this.editDialog = false
            this.copyItems = false
            this.alternatives = []
            this.alternative = false
            if (this.$refs.form) {
                this.$refs.form.reset()
            }
        },
        async saveAlternative(alternate, localFiles) {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''
                delete alternate.engineering
                delete alternate.createdBy
                delete alternate.engineeringIngressDate
                delete alternate.engExitBy
                delete alternate.engIngressBy
                delete alternate.indexAssign
                delete alternate.preDesign
                delete alternate.onHoldReasons
                delete alternate.exportTariff
                delete alternate.accessory
                delete alternate.engineeringExitDate
                delete alternate.preDesignReturned
                delete alternate.productType
                delete alternate.kind

                const engineeringDate = alternate.engineeringDate
                    ? alternate.engineeringDate
                    : ''
                const engineer = alternate.engineer ? alternate.engineer : ''
                const payload = _.omit(_.cloneDeep(alternate), [
                    'engineeringDate',
                    'engineer',
                ])
                delete alternate.engineeringDate
                delete alternate.engineer

                const cost = await API.createAlternativeCosts(this.quote.id, {
                    alternatives:
                        typeof this.alternatives == 'string'
                            ? [this.alternatives]
                            : [],
                    ...payload,
                })
                if (engineeringDate) {
                    const forEngineeringBody = {
                        engineering: true,
                        engineeringDate,
                    }
                    if (engineer) {
                        forEngineeringBody.engineer = engineer
                    }
                    const costForEngineering = await API.forEngineering(
                        this.quote.id,
                        cost.id,
                        forEngineeringBody
                    )
                    cost.engineeringDate = costForEngineering.engineeringDate
                    cost.engineering = costForEngineering.engineering
                    cost.engIngressBy = costForEngineering.engIngressBy
                    if (costForEngineering.engineer) {
                        cost.engineer = costForEngineering.engineer
                    }
                }

                if (alternate.preDesign) {
                    for (const item of localFiles) {
                        await saveFile(
                            item.file,
                            `${this.companyId}/quotes/${this.quote.id}/costs/${cost.id}`
                        )
                    }
                }
                this.setAlternatives([cost, ...this.getAlternatives])
                cost.documentId = cost.id
                this.currentAlternatives = [cost, ...this.currentAlternatives]
                this.currentAlternatives.sort((a, b) => {
                    return a.index - b.index
                })
                this.setTotal()
                await this.updateQuote()
                this.closeAddAlternative()
                this.action = {
                    active: true,
                    type: 'success',
                    message: 'Action successfully completed',
                    color: 'primary',
                }
            } catch (error) {
                this.action = {
                    active: true,
                    type: 'error',
                    message: 'Error executing the action',
                    color: 'error',
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.costToEdit = null
                this.newItemCost = {
                    totalSections: [],
                    sections: [],
                    total: 0,
                    total2: 0,
                    totalMargin2: 0,
                    commission2: 0,
                    quantity2: 0,
                    salePrice2: 0,
                    pricePerQuantity2: 0,
                    margin: 40,
                    measure: 'ft2',
                    totalMargin: 0,
                    commission: 0,
                    salePrice: 0,
                    pricePerQuantity: 0,
                    american: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                    international: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                }
            }
        },
        joinItems(items) {
            const tempItems = []
            for (let item of items) {
                for (let section of item.sections) {
                    const index = tempItems.findIndex(
                        e => e.name == section.name
                    )
                    if (index < 0) {
                        tempItems.push(section)
                    } else {
                        for (let cost of section.items) {
                            tempItems[index].items.push(cost)
                        }
                    }
                }
            }
            return tempItems
        },
        async addAlternatives() {
            try {
                this.loading = true
                this.alternative = true
                this.quoteChangesAction(false)
                if (this.copyItems) {
                    const costsAlternatives = this.currentItems.find(
                        item => item.id == this.alternatives
                    )
                    const costSections = this.settings
                        .find(s => s.name === 'Quotes')
                        ?.costSections?.map(cs => cs.name)
                    this.costToEdit = _.cloneDeep(costsAlternatives)
                    delete this.costToEdit.id
                    delete this.costToEdit.index
                    delete this.costToEdit.type
                    delete this.costToEdit.createdOn
                    delete this.costToEdit.onHoldReasons
                    delete this.costToEdit.exportTariff
                    delete this.costToEdit.updatedOn
                    delete this.costToEdit.accessory
                    delete this.costToEdit.documentId
                    delete this.costToEdit.productType
                    //////////////// clean data
                    this.costToEdit.sections = this.costToEdit.sections.filter(
                        s => costSections?.includes(s.name)
                    )
                    this.costToEdit.totalSections = this.costToEdit.totalSections.filter(
                        s => costSections?.includes(s.secName)
                    )
                    this.costToEdit.reference = this.alternativeName
                    this.originalCost = _.cloneDeep(this.costToEdit)
                    this.copyCost = false
                    this.editDialog = true
                } else {
                    this.newItemCost.reference = this.alternativeName
                    this.createDialogNewCost = true
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async createXLSX() {
            try {
                this.loading = true
                const data = []
                for (let cost of this.costs) {
                    for (let section of cost.sections) {
                        for (let item of section.items) {
                            const temp = {}
                            temp.Item = cost.reference
                            temp.Type = section.name
                            temp.TypeItem = item.name
                            temp.Weight = item.weight ? item.weight : 'none'
                            temp.Quantity = item.quantity
                            temp.Unit = item.unit
                            temp.Cost = item.cost
                            temp.Parcial = item.parcial.toFixed(2)
                            temp.Percentage = item.percentage
                            temp.TotalWeight = item.totalWeight.toFixed(2)
                            data.push(temp)
                        }
                    }
                }
                // only array possible
                var costsWS = XLSX.utils.json_to_sheet(data)

                // A workbook is the name given to an Excel file
                var wb = XLSX.utils.book_new() // make Workbook of Excel

                // add Worksheet to Workbook
                // Workbook contains one or more worksheets
                XLSX.utils.book_append_sheet(wb, costsWS, 'costs') // sheetAName is name of Worksheet

                // export Excel file
                XLSX.writeFile(wb, `${this.quote.name}.xlsx`) // name of the file is 'book.xlsx'
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async importCosts(costs) {
            try {
                this.loading = true
                this.costs.push(...costs)
                this.costsOnTable = _.cloneDeep(this.costs)
                this.setTotal()
                await this.updateQuote()
                this.quoteChangesAction(true)
                this.convertCost()
                this.importDialog = false
                this.dialogImportScope = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async importAlternates(alternates) {
            try {
                this.loading = true
                alternates.forEach(alternate => {
                    alternate.documentId = alternate.id
                    this.currentAlternatives.push(alternate)
                })

                this.currentAlternatives.sort((a, b) => a.index - b.index)

                this.setAlternatives(_.cloneDeep(this.currentAlternatives))

                await this.updateQuote()
                this.quoteChangesAction(true)
                this.convertCost()

                this.importDialog = false
                this.dialogImportScope = false

                this.action = {
                    active: true,
                    type: 'success',
                    message: `${alternates.length} alternate(s) imported successfully`,
                    color: 'primary',
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async importScopes(scopes) {
            try {
                this.loading = true
                this.costs.push(...scopes)
                this.costsOnTable = _.cloneDeep(this.costs)
                this.setTotal()
                await this.updateQuote()
                this.quoteChangesAction(true)
                this.convertCost()
                this.importScopesDialog = false
                this.dialogImportScope = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        makeid() {
            var length = 6
            var result = ''
            var characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            var charactersLength = characters.length
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                )
            }
            return result.toUpperCase()
        },
        openDialogDelete(item) {
            this.comToDelete = item
            this.deleteCommissions = true
        },
        deleteCommission: async function(commissionDetail) {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''

                // Create updated commissions array without the deleted commission
                const updatedCommissions = this.quote.commissions.filter(
                    u => u.details !== commissionDetail
                )

                // Calculate new margins locally for all costs
                const recalculatedCosts = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.costs),
                    updatedCommissions,
                    this.quote.exchange
                )

                // Calculate new margins locally for all alternatives
                const recalculatedAlternatives = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.currentAlternatives),
                    updatedCommissions,
                    this.quote.exchange
                )

                // Calculate new total costs
                const newTotalCosts = recalculatedCosts.reduce(
                    (accumulator, cost) => accumulator + cost.salePrice2,
                    0
                )

                // Send to API for update
                const {
                    quote,
                    costs,
                    alternatives,
                } = await API.updateCommissions(this.quote.id, {
                    commissions: updatedCommissions,
                    costs: recalculatedCosts,
                    alternatives: recalculatedAlternatives,
                    totalCosts: newTotalCosts,
                })

                // Update local state with the response
                this.quote.commissions = quote.commissions
                this.totalCosts = quote.totalCosts
                this.quote.totalCosts = this.totalCosts
                costs.forEach(cost => {
                    let index = -1
                    index = this.costs.findIndex(c => c.id === cost.id)
                    if (index > -1) {
                        this.costs[index] = { ...this.costs[index], ...cost }
                    }
                })
                this.costsOnTable = _.cloneDeep(this.costs)

                if (alternatives && alternatives.length > 0) {
                    alternatives.forEach(cost => {
                        let index = -1
                        index = this.currentAlternatives.findIndex(
                            c => c.id === cost.id
                        )
                        if (index > -1) {
                            this.currentAlternatives[index] = {
                                ...this.currentAlternatives[index],
                                ...cost,
                            }
                        }
                    })

                    // Force reactivity and sync with Vuex
                    this.currentAlternatives = [...this.currentAlternatives]
                    this.setAlternatives(_.cloneDeep(this.currentAlternatives))
                }

                this.deleteCommissions = false
                this.quoteChangesAction(false)

                this.action = {
                    active: true,
                    type: 'success',
                    message:
                        'Commission deleted and costs recalculated successfully',
                    color: 'primary',
                }
            } catch (error) {
                this.action = {
                    active: true,
                    type: 'error',
                    message: 'Error deleting commission',
                    color: 'error',
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDialogDelete() {
            this.deleteCommissions = false
            this.commision = null
        },
        closeDialogCommissions() {
            this.dialogCommissions = false
        },
        addCommissions: async function(commission) {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = ''

                // Create updated commissions array with the new commission
                const updatedCommissions = [
                    ...this.quote.commissions,
                    commission,
                ]

                // Calculate new margins locally for all costs
                const recalculatedCosts = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.costs),
                    updatedCommissions,
                    this.quote.exchange
                )

                // Calculate new margins locally for all alternatives
                const recalculatedAlternatives = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.currentAlternatives),
                    updatedCommissions,
                    this.quote.exchange
                )

                // Calculate new total costs
                const newTotalCosts = recalculatedCosts.reduce(
                    (accumulator, cost) => accumulator + cost.salePrice2,
                    0
                )

                // Send to API for update
                const {
                    quote,
                    costs,
                    alternatives,
                } = await API.updateCommissions(this.quote.id, {
                    commissions: updatedCommissions,
                    costs: recalculatedCosts,
                    alternatives: recalculatedAlternatives,
                    totalCosts: newTotalCosts,
                })
                // Update local state with the response
                this.quote.commissions = quote.commissions
                this.totalCosts = quote.totalCosts
                this.quote.totalCosts = this.totalCosts
                costs.forEach(cost => {
                    let index = -1
                    index = this.costs.findIndex(c => c.id === cost.id)
                    if (index > -1) {
                        this.costs[index] = { ...this.costs[index], ...cost }
                    }
                })
                this.costsOnTable = _.cloneDeep(this.costs)

                if (alternatives && alternatives.length > 0) {
                    alternatives.forEach(cost => {
                        let index = -1
                        index = this.currentAlternatives.findIndex(
                            c => c.id === cost.id
                        )
                        if (index > -1) {
                            this.currentAlternatives[index] = {
                                ...this.currentAlternatives[index],
                                ...cost,
                            }
                        }
                    })
                    this.currentAlternatives = [...this.currentAlternatives]
                    this.setAlternatives(_.cloneDeep(this.currentAlternatives))
                }

                this.dialogCommissions = false
                this.quoteChangesAction(false)

                this.action = {
                    active: true,
                    type: 'success',
                    message:
                        'Commission added and costs recalculated successfully',
                    color: 'primary',
                }
            } catch (error) {
                this.action = {
                    active: true,
                    type: 'error',
                    message: 'Error adding commission',
                    color: 'error',
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        // Pure calculation method for commissions - doesn't modify local state
        calculateMarginsForCommissions(costs, commissions, exchange) {
            return marginsForCommissions(costs, commissions, exchange)
        },
        async salesRepsForQuote() {
            const ids = quoteSalesRepIds(this.quote)
            if (!ids.length) return []
            let list = this.clients || []
            const match = (source, id) =>
                (source || []).find(
                    client =>
                        client.id === id && client.clientType === 'salesRep'
                )
            if (!ids.every(id => match(list, id))) {
                const {
                    data: { clients },
                } = await API.getClients()
                list = clients || []
            }
            return ids.map(id => match(list, id)).filter(Boolean)
        },
        async syncSalesRepCommissions() {
            if (this.syncingSalesRepCommissions || this.history) return
            const quote = this.quote
            if (
                !quote ||
                (quote.status !== 'OPEN' && quote.status !== 'APPROVAL')
            ) {
                return
            }
            if (quote.generatedByClient) return
            if (salesRepCommissionsManual(quote.commissions)) return
            if (!this.costs || !this.costs.length) return
            const ids = quoteSalesRepIds(quote)
            const reps = await this.salesRepsForQuote()
            if (!ids.length || reps.length !== ids.length) return
            const base = commissionBaseUsd(
                this.costs,
                this.quote,
                this.settings
            )
            console.log('Total USD con comisión 0', base)
            const lines = salesRepCommissionShare(reps, base)
            const next = mergeSalesRepCommissions(quote.commissions, lines)
            if (
                salesRepPercentKey(quote.commissions) ===
                salesRepPercentKey(next)
            ) {
                return
            }
            await this.persistCommissionLines(next)
        },
        async updateSalesRepCommission(commission) {
            const updated = (this.quote.commissions || []).map(row => {
                if (
                    !row?.salesRepId ||
                    row.salesRepId !== commission.salesRepId
                ) {
                    return row
                }
                return {
                    ...row,
                    percentage: Number(commission.percentage),
                    manual: true,
                }
            })
            await this.persistCommissionLines(updated)
            this.deleteCommissions = false
        },
        async persistCommissionLines(updatedCommissions) {
            this.syncingSalesRepCommissions = true
            try {
                this.loading = true
                const recalculatedCosts = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.costs),
                    updatedCommissions,
                    this.quote.exchange
                )
                const recalculatedAlternatives = this.calculateMarginsForCommissions(
                    _.cloneDeep(this.currentAlternatives),
                    updatedCommissions,
                    this.quote.exchange
                )
                const newTotalCosts = recalculatedCosts.reduce(
                    (accumulator, cost) => accumulator + cost.salePrice2,
                    0
                )
                const {
                    quote,
                    costs,
                    alternatives,
                } = await API.updateCommissions(this.quote.id, {
                    commissions: updatedCommissions,
                    costs: recalculatedCosts,
                    alternatives: recalculatedAlternatives,
                    totalCosts: newTotalCosts,
                })
                this.quote.commissions = quote.commissions
                this.totalCosts = quote.totalCosts
                this.quote.totalCosts = this.totalCosts
                costs.forEach(cost => {
                    const index = this.costs.findIndex(c => c.id === cost.id)
                    if (index > -1) {
                        this.costs[index] = { ...this.costs[index], ...cost }
                    }
                })
                this.costsOnTable = _.cloneDeep(this.costs)
                if (alternatives && alternatives.length > 0) {
                    alternatives.forEach(cost => {
                        const index = this.currentAlternatives.findIndex(
                            c => c.id === cost.id
                        )
                        if (index > -1) {
                            this.currentAlternatives[index] = {
                                ...this.currentAlternatives[index],
                                ...cost,
                            }
                        }
                    })
                    this.currentAlternatives = [...this.currentAlternatives]
                    this.setAlternatives(_.cloneDeep(this.currentAlternatives))
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.$nextTick(() => {
                    this.syncingSalesRepCommissions = false
                })
            }
        },
        setTotalMargin(arr) {
            for (const cost of arr) {
                let sumCommissions = 0
                if (cost.total) {
                    if (this.quote.commissions) {
                        if (this.quote.commissions.length > 0) {
                            sumCommissions = 0
                            this.quote.commissions.forEach(x => {
                                sumCommissions += parseFloat(x.percentage)
                            })
                        }
                    }

                    if (cost.exportTariff) {
                        sumCommissions = 0
                    }
                    const marginp = Number(cost.margin) / 100
                    const salesPrice1 = Number(cost.total) / (1 - marginp)
                    // const salesPrice2 =
                    //     salesPrice1 * (Number(sumCommissions) / 100)
                    let totalCommission = (
                        salesPrice1 /*+ salesPrice2*/ *
                        (Number(sumCommissions) / 100)
                    ).toFixed(2)
                    cost.commission = parseFloat(totalCommission)
                    let totalMargin = (
                        salesPrice1 -
                        /*salesPrice2 -
                        totalCommission -*/
                        Number(cost.total)
                    ).toFixed(2)
                    cost.totalMargin = parseFloat(totalMargin)
                    cost.salePrice = parseFloat(
                        salesPrice1 /*+ salesPrice2*/ + Number(totalCommission)
                    ).toFixed(2)
                    cost.total2 = parseFloat(
                        (
                            Number(cost.total) / Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    cost.totalMargin2 = parseFloat(
                        (
                            Number(cost.totalMargin) /
                            Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    cost.salePrice2 = parseFloat(
                        (
                            Number(cost.salePrice) / Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    cost.commission2 = parseFloat(
                        (cost.commission / Number(this.quote.exchange)).toFixed(
                            2
                        )
                    )
                    this.convertUnits(cost)
                    cost.pricePerQuantity = parseFloat(
                        (cost.salePrice / this.quantityInternational).toFixed(2)
                    )

                    cost.pricePerQuantity2 = parseFloat(
                        (cost.salePrice2 / cost.quantity2).toFixed(2)
                    )
                }
            }
        },
        openDialogCommissions() {
            if (!this.quote.commissions) {
                this.$set(this.quote, 'commissions', [])
            }
            this.dialogCommissions = true
        },
        newCost() {
            if (this.quote.clientId) {
                this.quoteChangesAction(false)
                this.createDialogNewCost = true
                this.createCostForm = true
                this.error = false
                this.errorMsg = ''
            } else {
                this.errorMsg =
                    'The currency and exchange rate cannot be loaded because there is no client selected'
                this.setErrorItems(this.errorMsg)
            }
        },
        selectExchange(event) {
            const index = this.exchanges.findIndex(u => u.currency === event)
            if (index >= 0) {
                this.quote.exchange = parseFloat(this.exchanges[index].money)
                this.exchange = parseFloat(this.exchanges[index].money)
                this.quoteChangesAction(false)
            } else {
                this.error = true
                this.errorMsg = 'Check the exchange currency'
                this.quote.exchange = 1
                this.exchange = 1
            }
            if (this.costs.length > 0) {
                this.convertCost()
            }
        },
        closeDialog() {
            this.createDialogNewCost = false
            this.alternative = false
            this.costToEdit = {}
            this.editAlternative = false
            this.newItemCost = {
                totalSections: [],
                sections: [],
                total: 0,
                total2: 0,
                totalMargin2: 0,
                commission2: 0,
                quantity2: 0,
                salePrice2: 0,
                pricePerQuantity2: 0,
                margin: 40,
                measure: 'ft2',
                totalMargin: 0,
                commission: 0,
                salePrice: 0,
                pricePerQuantity: 0,
                american: {
                    tw: 0,
                    wa: 0,
                    cw: 0,
                    pw: 0,
                    ca: 0,
                },
                international: {
                    tw: 0,
                    wa: 0,
                    cw: 0,
                    pw: 0,
                    ca: 0,
                },
            }
        },
        closeEditItem() {
            this.editDialog = false
            this.alternative = false
            this.originalCost = {}
            this.costToEdit = {}
        },
        handleOpenCostFormAction(payload) {
            if (!payload || !payload.costId) return
            const cost = this.costs.find(
                c => (c.id || c.document_id) === payload.costId
            )
            if (cost) {
                this.editItem(cost)
            }
        },
        editItem(item) {
            this.editAlternative = false
            this.costToEdit = {}
            if (
                this.getAlternatives.find(alternate => alternate.id == item.id)
            ) {
                this.editAlternative = true
            }

            // Always open with original values (without exterior toggle conversion)
            // The interior toggle in NewQuoteCostForm handles its own conversion
            this.costToEdit = _.cloneDeep(item)
            delete this.costToEdit.syncedExportTariff
            delete this.costToEdit.syncedTotalCosts

            this.originalCost = _.cloneDeep(this.costToEdit)
            this.copyCost = false
            this.editDialog = true
        },
        copyItem(item) {
            const copyItem = _.cloneDeep(item)
            this.newItemCost = {
                american: copyItem.american,
                commission: copyItem.commission,
                commission2: copyItem.commission2,
                description: copyItem.description,
                descriptionCost: copyItem.descriptionCost,
                international: copyItem.international,
                margin: copyItem.margin,
                measure: copyItem.measure,
                pricePerQuantity: copyItem.pricePerQuantity,
                pricePerQuantity2: copyItem.pricePerQuantity2,
                quantity: copyItem.quantity,
                quantity2: copyItem.quantity2,
                reference: copyItem.reference,
                salePrice: copyItem.salePrice,
                salePrice2: copyItem.salePrice2,
                sections: copyItem.sections,
                total: copyItem.total,
                total2: copyItem.total2,
                totalMargin: copyItem.totalMargin,
                totalMargin2: copyItem.totalMargin2,
                totalSections: copyItem.totalSections,
            }
            this.createCostForm = true
            this.createDialogNewCost = true
        },
        copyTerms() {
            this.copyExchange = _.cloneDeep(this.quote.exchange)
            this.copyCurrency = _.cloneDeep(this.quote.currency)
        },
        deleteItem(item) {
            this.permission = this.deletepermission()
            this.deleteDialog = true
            this.itemToDelete = item
        },
        deletepermission() {
            if (this.costsOnTable.length <= 1) {
                return false
            } else {
                return true
            }
        },
        async deleteCosts() {
            try {
                this.loading = true
                const index = this.costs.findIndex(
                    cost => cost.id == this.itemToDelete.id
                )
                this.costs.splice(index, 1)
                this.deleteDialog = false
                this.quoteChangesAction(false)
                await API.deleteCosts(this.quote.id, this.itemToDelete.id)
                this.setTotal()
                this.costsOnTable = _.cloneDeep(this.costs)
                this.spreadCosts(_.cloneDeep(this.costsOnTable))
                await this.updateQuote()
                this.quoteChangesAction(true)
                if (this.createTask) {
                    this.openTaskDialog(
                        this.costsOnTable[this.costsOnTable.length - 1]
                    )
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        ...mapActions([
            'replaceQuoteAction',
            'quoteChangesAction',
            'addContactsAction',
            'addUsersAction',
            'updateSeeMenuAction',
            'clearPendingAction',
        ]),
        createCosts: async function(localFiles) {
            try {
                this.loading = true
                const engineeringDate = this.newItemCost.engineeringDate
                    ? this.newItemCost.engineeringDate
                    : ''
                const engineer = this.newItemCost.engineer
                    ? this.newItemCost.engineer
                    : ''
                const payload = _.omit(_.cloneDeep(this.newItemCost), [
                    'index',
                    'engineeringDate',
                    'engineer',
                ])
                delete this.newItemCost.engineeringDate
                delete this.newItemCost.engineer
                let cost = await API.createCosts(this.quote.id, payload)
                if (engineeringDate) {
                    const forEngineeringBody = {
                        engineering: true,
                        engineeringDate,
                    }
                    if (engineer) {
                        forEngineeringBody.engineer = engineer
                    }
                    const costForEngineering = await API.forEngineering(
                        this.quote.id,
                        cost.id,
                        forEngineeringBody
                    )
                    cost.engineeringDate = costForEngineering.engineeringDate
                    cost.engineering = costForEngineering.engineering
                    cost.engIngressBy = costForEngineering.engIngressBy
                    if (costForEngineering.engineer) {
                        cost.engineer = costForEngineering.engineer
                    }
                }
                if (this.newItemCost.preDesign) {
                    for (const item of localFiles) {
                        await saveFile(
                            item.file,
                            `${this.companyId}/quotes/${this.quote.id}/costs/${cost.id}`
                        )
                    }
                }
                this.costs.push(cost)
                this.costsOnTable = _.cloneDeep(this.costs)
                this.setTotal()
                await this.updateQuote()
                this.quoteChangesAction(true)
                if (this.createTask) {
                    this.openTaskDialog(
                        this.costsOnTable[this.costsOnTable.length - 1]
                    )
                }
                this.editDialog = false
                this.newItemCost = {
                    totalSections: [],
                    sections: [],
                    total: 0,
                    total2: 0,
                    totalMargin2: 0,
                    commission2: 0,
                    quantity2: 0,
                    salePrice2: 0,
                    pricePerQuantity2: 0,
                    margin: 40,
                    measure: 'ft2',
                    totalMargin: 0,
                    commission: 0,
                    salePrice: 0,
                    pricePerQuantity: 0,
                    american: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                    international: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                }
                this.createDialogNewCost = false
                this.action = {
                    active: true,
                    type: 'success',
                    message: 'Action successfully completed',
                    color: 'primary',
                }
            } catch (error) {
                this.action = {
                    active: true,
                    type: 'error',
                    message: 'Error executing the action',
                    color: 'error',
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                return error
            } finally {
                this.spreadCosts(_.cloneDeep(this.costsOnTable))
                this.loading = false
            }
        },
        updateCosts: async function() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = null
                delete this.costToEdit.createdOn
                delete this.costToEdit.createdBy
                delete this.costToEdit.updatedOn
                delete this.costToEdit.documentId
                delete this.costToEdit.engineeringExitDate
                delete this.costToEdit.preDesignReturned
                this.stripCostMetadataForUpdate(this.costToEdit)
                const copyCost = _.cloneDeep(this.costToEdit)
                delete copyCost.preDesign
                const cost = await API.updateCosts(this.quote.id, {
                    ...copyCost,
                    ...(copyCost.engineeringDate &&
                    typeof copyCost.engineeringDate == 'object'
                        ? {
                              engineeringDate: moment
                                  .unix(
                                      copyCost.engineeringDate._seconds ||
                                          copyCost.engineeringDate.seconds
                                  )
                                  .format('YYYY-MM-DD'),
                          }
                        : {}),
                })
                if (cost && cost.updatedOn) {
                    this.quote.updatedOn = moment
                        .unix(cost.updatedOn._seconds)
                        .format('MMM/DD/YYYY h:mm a')
                }
                if (cost && typeof cost.engineeringDate == 'string') {
                    cost.engineeringDate = cost.engineeringDate.substring(0, 10)
                }
                const syncedQuoteFields = this.extractSyncedQuoteFields(cost)
                this.applySyncedExportTariffToQuote(syncedQuoteFields)
                const index = this.costs.findIndex(c => cost.id == c.id)
                if (index >= 0) {
                    this.costs.splice(index, 1, { ...this.costToEdit, ...cost })
                    this.costsOnTable.splice(index, 1, {
                        ...this.costToEdit,
                        ...cost,
                    })
                }
                this.setTotal()
                await this.updateQuote()
                this.quoteChangesAction(true)
                if (this.createTask) {
                    this.openTaskDialog(
                        this.costsOnTable[this.costsOnTable.length - 1]
                    )
                }
                this.createDialogNewCost = false
                this.editDialog = false
                this.newItemCost = {
                    totalSections: [],
                    sections: [],
                    total: 0,
                    total2: 0,
                    totalMargin2: 0,
                    commission2: 0,
                    quantity2: 0,
                    salePrice2: 0,
                    pricePerQuantity2: 0,
                    margin: 40,
                    measure: 'ft2',
                    totalMargin: 0,
                    commission: 0,
                    salePrice: 0,
                    pricePerQuantity: 0,
                    american: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                    international: {
                        tw: 0,
                        wa: 0,
                        cw: 0,
                        pw: 0,
                        ca: 0,
                    },
                }
                this.action = {
                    active: true,
                    type: 'success',
                    message: 'Action successfully completed',
                    color: 'primary',
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.spreadCosts(_.cloneDeep(this.costsOnTable))
                this.loading = false
            }
        },
        replaceQuote(id, quote) {
            this.replaceQuoteAction({ id, quote })
        },
        updateQuote: async function() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = null
                const { id } = this.quote
                let changes = { commissions: this.quote.commissions }
                for (const key in this.quote) {
                    if (
                        key !== 'clients' &&
                        key != 'client' &&
                        ((this.oldQuote[key] === undefined &&
                            this.quote[key] !== undefined) ||
                            (this.quote[key] !== undefined &&
                                JSON.stringify(this.quote[key]) !==
                                    JSON.stringify(this.oldQuote[key])))
                    ) {
                        changes[key] =
                            key === 'city'
                                ? this.quote[key].text
                                : this.quote[key]
                    }
                }
                const {
                    data: { quote },
                } = await API.updateQuote(id, {
                    notificationId: 'LrubMkCSfpNwEoXemQKL',
                    ...changes,
                    ...(this.quote.generatedByClient && changes.currency
                        ? { clientId: this.quote.clientId }
                        : {}),
                })
                this.oldQuote = Object.assign({}, this.quote)
                quote.createdOn = moment
                    .unix(quote.createdOn._seconds)
                    .format('MMM/DD/YYYY')
                quote.sequence = quote.updatedOn?._seconds || 0
                quote.updatedOn = moment
                    .unix(quote.updatedOn._seconds)
                    .format('MMM/DD/YYYY h:mm a')
                quote.users = this.quote.users
                quote.clients = this.quote.clients
                quote.client = this.quote.client
                quote.mainContact = this.quote.mainContact
                this.replaceQuoteAction({ id, quote })
                this.replaceQuoteLocal(id, { ...this.quote, ...quote })
                // function provided from the mainboard
                this.filterQuotes()
                this.quoteChangesAction(true)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.deleteDialog = false
            }
        },
        setTotal(element = null) {
            if (!element) {
                this.totalCosts = 0
                if (this.costs.length > 0) {
                    this.costs.forEach(element => {
                        this.totalCosts += element.salePrice2
                    })
                }
                this.quote.totalCosts = this.totalCosts
            }
        },
        async updateCostsInstallation(cost) {
            if (cost.type == 'cost') {
                const index = this.costs.findIndex(c => cost.id == c.id)
                if (index >= 0) {
                    this.costs.splice(index, 1, { ...this.costToEdit, ...cost })
                    this.costsOnTable.splice(index, 1, {
                        ...this.costToEdit,
                        ...cost,
                    })
                }
            } else if (cost.type == 'alternate') {
                const index = this.currentAlternatives.findIndex(
                    a => a.id == cost.id
                )
                this.currentAlternatives[index] = _.cloneDeep(cost)
                this.currentAlternatives = [...this.currentAlternatives]
                this.setAlternatives(this.currentAlternatives)
            }
            await API.setInstallationCost({
                quoteId: cost.quoteId,
                sections: cost.sections,
                id: cost.id,
            })
        },
        convertions(arr) {
            if (Number(this.quote.exchange) !== this.copyExchange) {
                arr.forEach(element => {
                    if (
                        this.quote.currency ==
                            this.settingExchange.globalCurrency &&
                        this.quote.exchange == 1
                    ) {
                        element.salePrice2 = element.salePrice
                        element.commission2 = element.commission
                        element.pricePerQuantity2 = element.pricePerQuantity
                        element.total2 = element.total
                        element.totalMargin2 = element.totalMargin
                    } else {
                        element.salePrice2 = parseFloat(
                            (
                                Number(element.salePrice) /
                                Number(this.quote.exchange)
                            ).toFixed(2)
                        )
                        element.commission2 = parseFloat(
                            (
                                Number(element.commission) /
                                Number(this.quote.exchange)
                            ).toFixed(2)
                        )
                        element.total2 = parseFloat(
                            (
                                Number(element.total) /
                                Number(this.quote.exchange)
                            ).toFixed(2)
                        )
                        element.totalMargin2 = parseFloat(
                            (
                                Number(element.totalMargin) /
                                Number(this.quote.exchange)
                            ).toFixed(2)
                        )
                        element.pricePerQuantity2 = parseFloat(
                            (
                                Number(element.salePrice2) /
                                Number(element.quantity2)
                            ).toFixed(2)
                        )
                    }
                    this.convertUnits(element)
                    this.convertAmericanStatistics(element)
                    this.convertInternationalStatistics(element)
                })
            } else {
                arr.forEach(element => {
                    element.salePrice2 = parseFloat(
                        (
                            element.salePrice / Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    element.commission2 = parseFloat(
                        (
                            element.commission / Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    element.total2 = parseFloat(
                        (element.total / Number(this.quote.exchange)).toFixed(2)
                    )
                    element.totalMargin2 = parseFloat(
                        (
                            element.totalMargin / Number(this.quote.exchange)
                        ).toFixed(2)
                    )
                    this.convertUnits(element)
                    element.pricePerQuantity2 = parseFloat(
                        (element.salePrice2 / element.quantity2).toFixed(2)
                    )
                    this.convertAmericanStatistics(element)
                    this.convertInternationalStatistics(element)
                })
            }
        },
        convertedCostFields(cost) {
            if (!cost || !cost.id) return null
            const fields = {
                id: cost.id,
                salePrice2: cost.salePrice2,
                commission2: cost.commission2,
                total2: cost.total2,
                totalMargin2: cost.totalMargin2,
                pricePerQuantity2: cost.pricePerQuantity2,
                quantity2: cost.quantity2,
            }
            if (cost.type) fields.type = cost.type
            if (cost.american) fields.american = cost.american
            if (cost.international) fields.international = cost.international
            return fields
        },
        async convertCost() {
            this.skipQuoteWatch = true
            this.skipAlternativeViewRecalc = true
            try {
                this.convertions(this.costs)
                this.convertions(this.currentAlternatives)
                if (
                    !this.history &&
                    !['SENT', 'clientPreApproved', 'clientApproved'].includes(
                        this.quote.status
                    ) &&
                    !this.isMounted
                ) {
                    const allCostsToUpdate = [
                        ...(this.costs || []),
                        ...(this.currentAlternatives || []),
                    ]
                        .map(cost => this.convertedCostFields(cost))
                        .filter(Boolean)
                    await this.updateAllCostsAndAlternatives(allCostsToUpdate)
                }
                if (this.showOriginalView) {
                    this.calculateAlternativeView()
                }
                this.copyTerms()
            } finally {
                this.$nextTick(() => {
                    this.skipQuoteWatch = false
                    this.skipAlternativeViewRecalc = false
                })
            }
        },
        convertAmericanStatistics(element = null) {
            const settingUnits = this.settings.find(u => u.name === 'Quotes')
            if (!element) {
                this.costs.forEach(element => {
                    if (element.american.tw > 0) {
                        element.american.cw = parseFloat(
                            (
                                Number(element.total2) /
                                Number(element.american.tw)
                            ).toFixed(2)
                        )
                        element.american.pw = parseFloat(
                            (
                                Number(element.salePrice2) /
                                Number(element.american.tw)
                            ).toFixed(2)
                        )
                    }
                    if (Number(element.quantity) > 0) {
                        if (Number(element.american.tw) > 0) {
                            //The unit weight is 0 if the unit of measure is not consistent for the calculation.
                            if (
                                settingUnits.measureUnits.find(
                                    unit =>
                                        unit.abbr == element.measure &&
                                        (unit.measure == 'time' ||
                                            unit.measure == 'mass')
                                )
                            ) {
                                element.american.wa = 0
                            } else {
                                element.american.wa = parseFloat(
                                    (
                                        Number(element.american.tw) /
                                        Number(element.quantity2)
                                    ).toFixed(2)
                                )
                            }
                        }
                        element.american.ca = parseFloat(
                            (
                                Number(element.total2) /
                                Number(element.quantity2)
                            ).toFixed(2)
                        )
                    }
                    if (element.american.tw === 0) {
                        element.american.wa = 0
                        element.american.cw = 0
                        element.american.pw = 0
                    }
                })
            } else {
                if (element.american.tw > 0) {
                    element.american.cw = parseFloat(
                        (
                            Number(element.total2) / Number(element.american.tw)
                        ).toFixed(2)
                    )
                    element.american.pw = parseFloat(
                        (
                            Number(element.salePrice2) /
                            Number(element.american.tw)
                        ).toFixed(2)
                    )
                }
                if (Number(element.quantity) > 0) {
                    if (Number(element.american.tw) > 0) {
                        //The unit weight is 0 if the unit of measure is not consistent for the calculation.
                        if (
                            settingUnits.measureUnits.find(
                                unit =>
                                    unit.abbr == element.measure &&
                                    (unit.measure == 'time' ||
                                        unit.measure == 'mass')
                            )
                        ) {
                            element.american.wa = 0
                        } else {
                            element.american.wa = parseFloat(
                                (
                                    Number(element.american.tw) /
                                    Number(element.quantity2)
                                ).toFixed(2)
                            )
                        }
                    }
                    element.american.ca = parseFloat(
                        (
                            Number(element.total2) / Number(element.quantity2)
                        ).toFixed(2)
                    )
                }
                if (element.american.tw === 0) {
                    element.american.wa = 0
                    element.american.cw = 0
                    element.american.pw = 0
                }
            }
        },
        convertInternationalStatistics(element = null) {
            const settingUnits = this.settings.find(u => u.name === 'Quotes')
            if (!element) {
                this.costs.forEach(element => {
                    if (element.international.tw > 0) {
                        element.international.cw = parseFloat(
                            (
                                Number(element.total) /
                                Number(element.international.tw)
                            ).toFixed(2)
                        )
                        element.international.pw = parseFloat(
                            (
                                Number(element.salePrice) /
                                Number(element.international.tw)
                            ).toFixed(2)
                        )
                    }
                    if (Number(element.quantity) > 0) {
                        if (Number(element.international.tw) > 0) {
                            //The unit weight is 0 if the unit of measure is not consistent for the calculation.
                            if (
                                settingUnits.measureUnits.find(
                                    unit =>
                                        unit.abbr == element.measure &&
                                        (unit.measure == 'time' ||
                                            unit.measure == 'mass')
                                )
                            ) {
                                element.international.wa = 0
                            } else {
                                element.international.wa = parseFloat(
                                    (
                                        Number(element.international.tw) /
                                        Number(this.quantityInternational)
                                    ).toFixed(2)
                                )
                            }
                        }
                        element.international.ca = parseFloat(
                            (
                                Number(element.total) /
                                Number(this.quantityInternational)
                            ).toFixed(2)
                        )
                    }

                    if (element.international.tw === 0) {
                        element.international.wa = 0
                        element.international.cw = 0
                        element.international.pw = 0
                    }
                })
            } else {
                if (Number(element.international.tw) > 0) {
                    element.international.cw = parseFloat(
                        (
                            Number(element.total) /
                            Number(element.international.tw)
                        ).toFixed(2)
                    )
                    element.international.pw = parseFloat(
                        (
                            Number(element.salePrice) /
                            Number(element.international.tw)
                        ).toFixed(2)
                    )
                }
                if (Number(element.quantity) > 0) {
                    if (Number(element.international.tw) > 0) {
                        //The unit weight is 0 if the unit of measure is not consistent for the calculation.
                        if (
                            settingUnits.measureUnits.find(
                                unit =>
                                    unit.abbr == element.measure &&
                                    (unit.measure == 'time' ||
                                        unit.measure == 'mass')
                            )
                        ) {
                            element.international.wa = 0
                        } else {
                            element.international.wa = parseFloat(
                                (
                                    Number(element.international.tw) /
                                    Number(this.quantityInternational)
                                ).toFixed(2)
                            )
                        }
                    }
                    element.international.ca = parseFloat(
                        (
                            Number(element.total) /
                            Number(this.quantityInternational)
                        ).toFixed(2)
                    )
                }

                if (element.international.tw === 0) {
                    element.international.wa = 0
                    element.international.cw = 0
                    element.international.pw = 0
                }
            }
        },
        setSettings() {
            const indexExchanges = this.settings.findIndex(
                u => u.name === 'Exchange'
            )
            this.settingExchange = this.settings[indexExchanges]
            this.exchanges = this.settingExchange.exchanges
            this.globalCurrency = this.settingExchange.globalCurrency
            this.exchanges.forEach(v => this.itemsCurrency.push(v.currency))
            this.itemsCurrency.push(this.globalCurrency)
            if (
                this.quote.clientId === null ||
                this.quote.clientId === undefined
            ) {
                this.error = true
                this.errorMsg =
                    'The currency and exchange rate cannot be loaded because there is no client selected'
                this.quote.exchange = 1
                this.exchange = 1
            }
            if (this.costs && this.costs.length > 0) {
                this.newCommissions()
                this.setTotal()
            }
            this.costsOnTable = this.costs
            this.costsOnTable.sort((a, b) => {
                return a.index - b.index
            })
        },
        newCommissions() {
            if (this.quote.commissions) {
                if (this.quote.commissions.length > 0) {
                    this.sumCommissions = 0
                    this.quote.commissions.forEach(x => {
                        this.sumCommissions += parseFloat(x.percentage)
                    })
                }
            }
            this.costs.forEach(element => {
                const marginp = Number(element.margin) / 100
                const salesPrice1 = Number(element.total) / (1 - marginp)
                // const salesPrice2 =
                //     salesPrice1 *
                //     (Number(element.exportTariff ? 0 : this.sumCommissions) /
                //         100)
                const totalCommission = (
                    salesPrice1 /*+ salesPrice2*/ *
                    (Number(element.exportTariff ? 0 : this.sumCommissions) /
                        100)
                ).toFixed(2)
                const totalMargin = (
                    salesPrice1 -
                    /*salesPrice2 -
                    totalCommission -*/
                    element.total
                ).toFixed(2)
                element.totalMargin = parseFloat(totalMargin)
                element.commission = parseFloat(totalCommission)
                element.salePrice = parseFloat(
                    (
                        salesPrice1 /*+ salesPrice2*/ + Number(totalCommission)
                    ).toFixed(2)
                )
                this.convertUnits(element)
                const pricePerQ = element.salePrice / this.quantityInternational
                element.pricePerQuantity = parseFloat(pricePerQ.toFixed(2))
            })
            this.convertCost()
        },

        async getContacts() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = null
                const {
                    data: { contacts },
                } = await API.getContacts(this.companyId)
                for (const contact of contacts) {
                    if (contact.picture) {
                        const path = `${this.companyId}/${this.folderClientsPictures}`
                        const storageRef = storage().ref(path)
                        const profilePicRef = storageRef.child(contact.picture)
                        await profilePicRef
                            .getDownloadURL()
                            .then(url => {
                                contact.profilePicURL = url
                            })
                            .catch(error => {
                                contact.profilePicRef = ''
                                error && true
                            })
                    }
                }
                this.addContactsAction(contacts)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        getUsers: async function() {
            try {
                this.error = false
                this.errorMsg = null
                this.loading = true
                const {
                    data: { users },
                } = await API.getUsers(this.companyId)
                for (const user of users) {
                    if (user.picture) {
                        const path = `${this.companyId}/${this.folderUsersPictures}`
                        const storageRef = storage().ref(path)
                        const profilePicRef = storageRef.child(user.picture)
                        await profilePicRef
                            .getDownloadURL()
                            .then(url => {
                                user.profilePicURL = url
                            })
                            .catch(error => {
                                user.profilePicRef = ''
                                error && true
                            })
                    }
                    user.createdOn = moment
                        .unix(user.createdOn._seconds)
                        .format('MMM/DD/YYYY HH:mm')
                }
                this.addUsersAction(users)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        convertUnits(element) {
            const settingUnits = this.settings.find(u => u.name === 'Quotes')

            if (element.measure == 'qt' || element.measure == 'QT') {
                element.quantity2 = element.quantity
                this.quantityInternational = element.quantity
            } else if (
                settingUnits.measureUnits.find(
                    unit =>
                        unit.abbr == element.measure && unit.measure == 'time'
                )
            ) {
                element.quantity2 = element.quantity
                this.quantityInternational = element.quantity
            } else if (
                settingUnits.measureUnits.find(
                    unit =>
                        unit.abbr == element.measure && unit.measure == 'mass'
                )
            ) {
                element.quantity2 = Number(element.quantity)
                this.quantityInternational = Number(element.quantity)
            } else if (element.measure == 'yd2') {
                element.quantity2 = parseFloat(
                    (Number(element.quantity) / 0.111111).toFixed(2)
                )
                this.quantityInternational = parseFloat(
                    (Number(element.quantity) / 1.19599).toFixed(2)
                )
            } else if (
                settingUnits.measureUnits.find(unit => {
                    if (
                        unit.abbr == element.measure &&
                        unit.measure == 'length'
                    ) {
                        return true
                    }
                })
            ) {
                element.quantity2 = parseFloat(
                    convert(element.quantity)
                        .from(element.measure)
                        .to('ft')
                )
                this.quantityInternational = parseFloat(
                    convert(element.quantity)
                        .from(element.measure)
                        .to('m')
                )
            } else {
                element.quantity2 = parseFloat(
                    convert(element.quantity)
                        .from(element.measure)
                        .to('ft2')
                )
                this.quantityInternational = parseFloat(
                    convert(element.quantity)
                        .from(element.measure)
                        .to('m2')
                )
            }
        },
        async updateAllCosts(costs) {
            try {
                const newCosts = await API.updateAllCosts({
                    quoteId: this.quote.id,
                    costs: costs.map(cost => {
                        delete cost.createdOn
                        delete cost.updatedOn
                        delete cost.documentId
                        delete cost.engineeringExitDate
                        delete cost.preDesignReturned
                        delete cost.onHoldReasons
                        delete cost.engExitBy
                        delete cost.engIngressBy
                        delete cost.engineeringIngressDate
                        if (!this.isExportTariffCost(cost)) {
                            delete cost.accessory
                            delete cost.exportTariff
                        }
                        delete cost.preDesign
                        delete cost.productType
                        return cost
                    }),
                })
                for (const cost of newCosts) {
                    if (cost && typeof cost.engineeringDate == 'string') {
                        cost.engineeringDate = cost.engineeringDate.substring(
                            0,
                            10
                        )
                    }
                    const index = this.costs.findIndex(c => cost.id == c.id)
                    if (index >= 0) {
                        this.costs.splice(index, 1, {
                            ...this.costs[index],
                            ...cost,
                        })
                        this.costsOnTable.splice(index, 1, {
                            ...this.costsOnTable[index],
                            ...cost,
                        })
                    }
                }
                this.setTotal()
                await this.updateQuote()
                this.quoteChangesAction(true)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async updateAllCostsAndAlternatives(allCosts) {
            try {
                this.setTotal()
                const { id } = this.quote
                const quotePayload = {
                    companyId: this.quote.companyId || this.companyId,
                    currency: this.quote.currency,
                    exchange: Number(this.quote.exchange),
                    totalCosts: this.quote.totalCosts,
                    notificationId: 'LrubMkCSfpNwEoXemQKL',
                }
                if (this.quote.generatedByClient) {
                    quotePayload.clientId = this.quote.clientId
                }
                if (allCosts.length > 0) {
                    await API.updateAllCosts({
                        quoteId: id,
                        costs: allCosts,
                    })
                }
                await API.updateQuote(id, quotePayload)
                if (this.currentAlternatives.length > 0) {
                    this.setAlternatives(_.cloneDeep(this.currentAlternatives))
                }
                this.oldQuote = Object.assign({}, this.quote)
                this.replaceQuoteAction({ id, quote: this.quote })
                this.replaceQuoteLocal(id, { ...this.quote })
                if (this.filterQuotes) this.filterQuotes()
                this.quoteChangesAction(true)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
    },
    async mounted() {
        this.updateSeeMenuAction(false)
        this.isMounted = true
        if (this.settings) {
            this.setSettings()
        } else {
            const {
                data: { settings },
            } = await API.getSettings()
            const indexExchanges = settings.findIndex(
                u => u.name === 'Exchange'
            )
            this.settingExchange = settings[indexExchanges]
            this.exchanges = this.settingExchange.exchanges
            this.globalCurrency = this.settingExchange.globalCurrency
            this.exchanges.forEach(v => this.itemsCurrency.push(v.currency))
            this.itemsCurrency.push(this.globalCurrency)
        }
        const quoteSetting = this.settings.find(
            setting => setting.name === 'Quotes'
        )
        this.quoteProductTypes = (quoteSetting.quoteProductTypes || []).sort(
            (a, b) => {
                const nameA = (a.name || '').toLowerCase()
                const nameB = (b.name || '').toLowerCase()
                return nameA.localeCompare(nameB)
            }
        )
        const invoiceSettings = this.settings.find(
            setting => setting.name.toLowerCase() == 'invoicing'
        )
        this.categories = invoiceSettings.categories
        if (this.quote) {
            this.copyTerms()
            // If showOriginalView is active, calculate alternative view
            if (this.showOriginalView) {
                this.calculateAlternativeView()
            }
        }

        if (this.currentAlternatives.length > 0) {
            if (
                this.currentAlternatives.every(
                    alternate =>
                        alternate.index == undefined || alternate.index == 0
                )
            ) {
                for (const index in this.currentAlternatives) {
                    this.currentAlternatives[index].index = Number(index) + 1
                    await API.updateCosts(this.quote.id, {
                        id: this.currentAlternatives[index].id,
                        index: this.currentAlternatives[index].index,
                    })
                }
            }
            this.currentAlternatives.sort((a, b) => a.index - b.index)
        }
        this.isMounted = false
        const {
            data: { user },
        } = await API.getMyInfo()
        const createTask = user.permissions.find(x => x == 'createTask')
        if (createTask) {
            this.createTask = true
        }
        if (this.quote.estimatorId && this.quote.estimatorId == user.id) {
            const notificationId = 'x4KP5EMG94gwjayCVSfv'
            await API.checkAlertNotification({
                resourceId: this.quote.id,
                notificationId,
            })
        }
        this.updateSeeMenuAction(true)
    },
}
</script>

<style scoped>
.v-data-table >>> table {
    border: thin solid #eeeeee;
}
.no-border {
    border: none !important;
}
tr:not(:last-child) > td.border-grey {
    border-bottom: thin solid #eeeeee !important;
}
tr:hover {
    background: unset !important;
}
th,
td {
    font-size: 0.875rem !important;
}
.invisible {
    visibility: hidden;
}
.costs-table-footer {
    background-color: #eee;
}

.costs-table-footer:hover {
    background-color: #eee;
}
</style>
